<template>
	<div>
		<div class="wjType">
			<div class="wjTypeChild" :style="{ height: height + 'px' }" style="overflow-y: hidden">
				<div
					style="text-align: center"
					class="wjTypeChildItemFont"
					:class="{
						wjTypeChildItem: index != 0,
						iconActive: index == selectIndex
					}"
					v-for="(item, index) in tx_setting"
					:key="item.id"
				>
					<div class="icon">
						<img :src="item.icon2" v-if="index == selectIndex" style="margin-top: 12px !important" @click="selectIcon(index, item.id)" />
						<img :src="item.icon" v-else style="margin-top: 12px !important" @click="selectIcon(index, item.id)" />
					</div>
					<span @click="selectIcon(index, item.id)">{{ item.label }}</span>
				</div>
			</div>
			<div class="wjTypeChildQuestion" :style="{ height: height + 'px' }" v-if="selectIndex == 0 || selectIndex == 1">
				<div class="center" style="margin-bottom: 6px">
					<el-radio-group v-model="qtypeval" size="mini"><el-radio-button :label="qtype" v-for="qtype in qtypes" :key="qtype"></el-radio-button></el-radio-group>
				</div>
				<!-- 题型选择 -->
				<div :collapse="isCollapse" style="width: 100%" v-if="selectIndex == 0">
					<el-collapse v-model="activeNames">
						<el-collapse-item :title="askType.questionsTypeName" :name="index" v-for="(askType, index) in asklist" :key="index">
							<div style="height: auto" class="wjTypeChildItemFont qtypeItem" v-for="(item, typeindex) in askType.questionTypeList" :key="index + '-' + typeindex">
								<div class="icon" @click="selectTypeQuestion(index, item)"><img :src="item.iconUrlUnchecked" style="margin-top: 12px !important" /></div>
								<span style="font-size: 13px">{{ item.questionsTypeName }}</span>
							</div>
						</el-collapse-item>
					</el-collapse>
				</div>
				<div v-else-if="selectIndex == 1">
					<div class="tk_item" style="height: 0px !important"></div>
					<div class="tk_item" v-for="(wjType, index) in wjTypeList" :key="index" @click="showQuestionList(index, wjType)">
						<div class="display_inline" style="width: 5%"></div>
						<div class="display_inline" style="width: 65%; font-size: 16px" v-if="index != selectTypeIndex">{{ wjType.questionnaireTypeName }}</div>
						<div class="display_inline" style="width: 65%; font-size: 16px; color: cornflowerblue" v-if="index == selectTypeIndex">
							{{ wjType.questionnaireTypeName }}
						</div>
						<div class="display_inline" style="width: 25%; text-align: right">
							<img src="../assets/tk/jt_def_icon.png" v-if="index != selectTypeIndex" />
							<img src="../assets/tk/jt_sel_icon.png" v-if="index == selectTypeIndex" />
						</div>
					</div>
				</div>
			</div>
			<div class="wjTypeChildQuestion" :style="{ height: height + 'px' }" v-else-if="selectIndex == 4">
				<div class="tk_item" style="height: 0px !important"></div>
				<div class="tk_item" v-for="(szType, index) in szTypeList" :key="index" @click="selectSzItem(szType)">
					<div class="display_inline" style="width: 5%"></div>

					<div class="display_inline" style="width: 65%; font-size: 16px; color: gray">{{ szType.title }}</div>
					<div class="display_inline" style="width: 25%; text-align: right"><img src="../assets/tk/jt_def_icon.png" /></div>
				</div>
			</div>
		</div>
		
		<div v-if="selectIndex == 0" id="wenjuan_list" class="wjEdit" :style="{ height: rightheight + 'px' }" style="width: calc(100% - 720px); overflow-y: auto">
			<div v-if="selectIndex != 4">
				<div
					:style="{
						position: 'absolute',
						top: top - 40 + 'px',
						left: left + 'px',
						height: '30px',
						zIndex: 999,
						display: display
					}"
				>
					<table>
						<tr>
							<td class="operate_td"><i class="el-icon-picture"></i></td>
							<td class="operate_td" @click="outerVisible = true"><i class="el-icon-tickets"></i></td>
						</tr>
					</table>
				</div>
				<el-container>
					<el-main @mousewheel="scroll">
						<el-row :gutter="10" class="item_container">
							<el-row :gutter="10">
								<el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"><span style="color: #fff">题</span></el-col>
								<el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22" class="item_container_title" style="text-align: center">
									<!-- <el-input
                    placeholder="请输入问卷标题"
                    class="wjTitle"
                    @focus="showAdvance"
                    v-model="curWjInfo.wjTitle"
                    @blur="wjedit()"
                  ></el-input> -->
									<contenteditable-div @focus="showAdvance" v-model="curWjInfo.wjTitle" class="wj-title" @blur="wjedit()">
										{{ curWjInfo.wjTitle }}
									</contenteditable-div>
								</el-col>
							</el-row>
							<el-row :gutter="10" style="margin-top: 12px !important">
								<el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1"><span style="color: #fff">题</span></el-col>
								<el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22" class="item_container_title">
									<!-- <el-input
                    placeholder="请输入问卷欢迎语"
                    @focus="showAdvance"
                    v-model="curWjInfo.content"
                    @blur="wjedit()"
                  ></el-input> -->
									<contenteditable-div @focus="showAdvance" v-model="curWjInfo.content" @blur="wjedit()">请输入问卷欢迎语</contenteditable-div>
								</el-col>
							</el-row>
						</el-row>
						<el-row v-if="!questionlist || !questionlist.length">
							<div
								style="
                  text-align: center;
                  height: 300px;
                  line-height: 300px;
                  border: 1px blue dashed;
                "
							>
								点击题型可添加题目
							</div>
						</el-row>
						<el-row :gutter="10" :id="index" class="item_container" v-for="(item, index) in questionlist" :key="index">
							<!-- 手机号 -->
							<QuestionBlank
								v-if="item.questionsTypeId == 2"
								:index="index"
								:question="item"
								:editIndex="editIndex"
								:editOptionIndex="editOptionIndex"
								@questiondel="questiondel"
								@showAdvance="showAdvance"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@wjupdquestionoption="wjupdquestionoption"
								@wjupdoption="wjupdoption"
							/>
							<!-- 单行输入框 -->
							<QuestionBlank
								v-if="item.questionsTypeId == 3"
								:index="index"
								:question="item"
								:editIndex="editIndex"
								:editOptionIndex="editOptionIndex"
								@questiondel="questiondel"
								@showAdvance="showAdvance"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@wjupdquestionoption="wjupdquestionoption"
								@wjupdoption="wjupdoption"
							/>
							<!-- 多行输入框 -->
							<QuestionBlankMult
								v-if="item.questionsTypeId == 4"
								:index="index"
								:question="item"
								:editIndex="editIndex"
								:editOptionIndex="editOptionIndex"
								@wjaddquestionoption="wjaddquestionoption"
								@wjdelquestionoption="wjdelquestionoption"
								@questiondel="questiondel"
								@showAdvance="showAdvance"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@wjupdquestionoption="wjupdquestionoption"
								@wjupdoption="wjupdoption"
							/>
							<!-- 填空题 -->
							<QuestionBlank
								v-if="item.questionsTypeId == 5"
								:index="index"
								:question="item"
								:editIndex="editIndex"
								:editOptionIndex="editOptionIndex"
								@questiondel="questiondel"
								@showAdvance="showAdvance"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@wjupdquestionoption="wjupdquestionoption"
								@wjupdoption="wjupdoption"
							/>
							<!-- 图片选择 -->
							<QuestionImage
								v-model="value1"
								v-if="item.questionsTypeId == 6"
								:index="index"
								:question="item"
								:editIndex="editIndex"
								:editOptionIndex="editOptionIndex"
								@wjaddquestionoption="wjaddquestionoption"
								@wjdelquestionoption="wjdelquestionoption"
								@addmatrixquestionsoption="addMatrixQuestionsOption"
								@questiondel="questiondel"
								@showAdvance="showAdvance"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@wjupdquestionoption="wjupdquestionoption"
								@wjupdoption="wjupdoption"
								@addquestionitem="addQuestionItem"
							/>
							<!--单项选择题-->
							<QuestionSingle2
								v-if="item.questionsTypeId == 8"
								:index="index"
								:question="item"
								:editIndex="editIndex"
								:editOptionIndex="editOptionIndex"
								@wjaddquestionoption="wjaddquestionoption"
								@wjdelquestionoption="wjdelquestionoption"
								@questiondel="questiondel"
								@showAdvance="showAdvance"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@wjupdquestionoption="wjupdquestionoption"
								@wjupdoption="wjupdoption"
							/>
							<!-- 下拉框 -->
							<QuestionDropDownBox
								v-model="value1"
								v-if="item.questionsTypeId == 9"
								:index="index"
								:question="item"
								:editIndex="editIndex"
								:editOptionIndex="editOptionIndex"
								@wjaddquestionoption="wjaddquestionoption"
								@wjdelquestionoption="wjdelquestionoption"
								@addmatrixquestionsoption="addMatrixQuestionsOption"
								@questiondel="questiondel"
								@showAdvance="showAdvance"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@wjupdquestionoption="wjupdquestionoption"
								@wjupdoption="wjupdoption"
								@addquestionitem="addQuestionItem"
							/>
							<!--多项选择题-->
							<!-- || item.questionsTypeId==14 -->
							<QuestionMult2
								v-if="item.questionsTypeId == 10"
								:index="index"
								:question="item"
								:editIndex="editIndex"
								:editOptionIndex="editOptionIndex"
								@wjaddquestionoption="wjaddquestionoption"
								@wjdelquestionoption="wjdelquestionoption"
								@questiondel="questiondel"
								@showAdvance="showAdvance"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@wjupdquestionoption="wjupdquestionoption"
								@wjupdoption="wjupdoption"
							/>
							<!-- 星级评分 -->
							<QuestionRate
								v-if="item.questionsTypeId == 11"
								:index="index"
								:question="item"
								:editIndex="editIndex"
								:editOptionIndex="editOptionIndex"
								@wjaddquestionoption="wjaddquestionoption"
								@wjdelquestionoption="wjdelquestionoption"
								@questiondel="questiondel"
								@showAdvance="showAdvance"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@wjupdquestionoption="wjupdquestionoption"
								@wjupdoption="wjupdoption"
							/>
							<!--判断题-->
							<QuestionJudge
								v-if="item.questionsTypeId == 12"
								:index="index"
								:question="item"
								:editIndex="editIndex"
								:editOptionIndex="editOptionIndex"
								@wjaddquestionoption="wjaddquestionoption"
								@wjdelquestionoption="wjdelquestionoption"
								@questiondel="questiondel"
								@showAdvance="showAdvance"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@wjupdquestionoption="wjupdquestionoption"
								@wjupdoption="wjupdoption"
							/>
							<!-- 日期选择 -->
							<QuestionDate
								v-model="value1"
								v-if="item.questionsTypeId == 13"
								:index="index"
								:question="item"
								:editIndex="editIndex"
								:editOptionIndex="editOptionIndex"
								@wjaddquestionoption="wjaddquestionoption"
								@wjdelquestionoption="wjdelquestionoption"
								@addmatrixquestionsoption="addMatrixQuestionsOption"
								@questiondel="questiondel"
								@showAdvance="showAdvance"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@wjupdquestionoption="wjupdquestionoption"
								@wjupdoption="wjupdoption"
								@addquestionitem="addQuestionItem"
							/>
							<!-- 排序题 -->
							<QuestionSort
								v-model="value1"
								v-if="item.questionsTypeId == 14"
								:index="index"
								:question="item"
								:editIndex="editIndex"
								:editOptionIndex="editOptionIndex"
								@wjaddquestionoption="wjaddquestionoption"
								@wjdelquestionoption="wjdelquestionoption"
								@addmatrixquestionsoption="addMatrixQuestionsOption"
								@questiondel="questiondel"
								@showAdvance="showAdvance"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@wjupdquestionoption="wjupdquestionoption"
								@wjupdoption="wjupdoption"
								@addquestionitem="addQuestionItem"
							/>
							<!-- 地址位置 -->
							<QuestionAddress
								v-model="value1"
								v-if="item.questionsTypeId == 15"
								:index="index"
								:question="item"
								:titleNumber="titleNumber"
								:editIndex="editIndex"
								:editOptionIndex="editOptionIndex"
								@wjaddquestionoption="wjaddquestionoption"
								@wjdelquestionoption="wjdelquestionoption"
								@addmatrixquestionsoption="addMatrixQuestionsOption"
								@questiondel="questiondel"
								@showAdvance="showAdvance"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@wjupdquestionoption="wjupdquestionoption"
								@wjupdoption="wjupdoption"
								@addquestionitem="addQuestionItem"
							/>
							<!-- 城市选择 -->
							<QuestionCity
								v-model="value1"
								v-if="item.questionsTypeId == 16"
								:index="index"
								:question="item"
								:editIndex="editIndex"
								:titleNumber="titleNumber"
								:editOptionIndex="editOptionIndex"
								@wjaddquestionoption="wjaddquestionoption"
								@wjdelquestionoption="wjdelquestionoption"
								@addmatrixquestionsoption="addMatrixQuestionsOption"
								@questiondel="questiondel"
								@showAdvance="showAdvance"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@wjupdquestionoption="wjupdquestionoption"
								@wjupdoption="wjupdoption"
								@addquestionitem="addQuestionItem"
							/>
							<!-- 时间选择 -->
							<QuestionTime
								v-model="value1"
								v-if="item.questionsTypeId == 17"
								:index="index"
								:question="item"
								:editIndex="editIndex"
								:editOptionIndex="editOptionIndex"
								@wjaddquestionoption="wjaddquestionoption"
								@wjdelquestionoption="wjdelquestionoption"
								@addmatrixquestionsoption="addMatrixQuestionsOption"
								@questiondel="questiondel"
								@showAdvance="showAdvance"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@wjupdquestionoption="wjupdquestionoption"
								@wjupdoption="wjupdoption"
								@addquestionitem="addQuestionItem"
							/>
							<!-- 矩阵单选 -->
							<QuestionRectSingle
								v-if="item.questionsTypeId == 19"
								:index="index"
								:question="item"
								:editIndex="editIndex"
								:editOptionIndex="editOptionIndex"
								@wjaddquestionoption="wjaddquestionoption"
								@wjdelquestionoption="wjdelquestionoption"
								@addmatrixquestionsoption="addMatrixQuestionsOption"
								@questiondel="questiondel"
								@showAdvance="showAdvance"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@wjupdquestionoption="wjupdquestionoption"
								@wjupdoption="wjupdoption"
								@addquestionitem="addQuestionItem"
							/>
							<!-- 矩阵多选 -->
							<QuestionRectMult
								v-if="item.questionsTypeId == 20"
								:index="index"
								:question="item"
								:editIndex="editIndex"
								:editOptionIndex="editOptionIndex"
								@wjaddquestionoption="wjaddquestionoption"
								@wjdelquestionoption="wjdelquestionoption"
								@addmatrixquestionsoption="addMatrixQuestionsOption"
								@questiondel="questiondel"
								@showAdvance="showAdvance"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@wjupdquestionoption="wjupdquestionoption"
								@wjupdoption="wjupdoption"
								@addquestionitem="addQuestionItem"
							/>
							<!-- 矩阵星级评分 -->
							<QuestionMatrixRate
								v-if="item.questionsTypeId == 21"
								:index="index"
								:question="item"
								:editIndex="editIndex"
								:editOptionIndex="editOptionIndex"
								@wjaddquestionoption="wjaddquestionoption"
								@wjdelquestionoption="wjdelquestionoption"
								@addmatrixquestionsoption="addMatrixQuestionsOption"
								@questiondel="questiondel"
								@showAdvance="showAdvance"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@wjupdquestionoption="wjupdquestionoption"
								@wjupdoption="wjupdoption"
								@addquestionitem="addQuestionItem"
							/>
							<!-- 矩阵填空 -->

							<QuestionMatrixBlank
								v-if="item.questionsTypeId == 22"
								:index="index"
								:question="item"
								:editIndex="editIndex"
								:editOptionIndex="editOptionIndex"
								@wjaddquestionoption="wjaddquestionoption"
								@wjdelquestionoption="wjdelquestionoption"
								@addmatrixquestionsoption="addMatrixQuestionsOption"
								@questiondel="questiondel"
								@showAdvance="showAdvance"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@wjupdquestionoption="wjupdquestionoption"
								@wjupdoption="wjupdoption"
								@addquestionitem="addQuestionItem"
							/>
							<!-- 段落标题 -->
							<QuestionParagraph
								v-if="item.questionsTypeId == 25"
								:index="index"
								:question="item"
								:editIndex="editIndex"
								:editOptionIndex="editOptionIndex"
								@wjaddquestionoption="wjaddquestionoption"
								@wjdelquestionoption="wjdelquestionoption"
								@addmatrixquestionsoption="addMatrixQuestionsOption"
								@questiondel="questiondel"
								@showAdvance="showAdvance"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@wjupdquestionoption="wjupdquestionoption"
								@wjupdoption="wjupdoption"
								@addquestionitem="addQuestionItem"
							/>
							<!-- 分页 -->
							<QuestionPaging
								v-if="item.questionsTypeId == 26"
								:index="index"
								:question="item"
								:editIndex="editIndex"
								:editOptionIndex="editOptionIndex"
								@wjaddquestionoption="wjaddquestionoption"
								@wjdelquestionoption="wjdelquestionoption"
								@addmatrixquestionsoption="addMatrixQuestionsOption"
								@questiondel="questiondel"
								@showAdvance="showAdvance"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@wjupdquestionoption="wjupdquestionoption"
								@wjupdoption="wjupdoption"
								@addquestionitem="addQuestionItem"
							/>
							<!-- 上传文件 -->
							<QuestionUploadFile
								v-if="item.questionsTypeId == 33"
								:index="index"
								:question="item"
								:editIndex="editIndex"
								:editOptionIndex="editOptionIndex"
								@wjaddquestionoption="wjaddquestionoption"
								@wjdelquestionoption="wjdelquestionoption"
								@addmatrixquestionsoption="addMatrixQuestionsOption"
								@questiondel="questiondel"
								@showAdvance="showAdvance"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@wjupdquestionoption="wjupdquestionoption"
								@wjupdoption="wjupdoption"
								@addquestionitem="addQuestionItem"
							/>
							<!-- 横向填空 -->
							<QuestionCrosswiseBlank
								v-if="item.questionsTypeId == 34"
								:index="index"
								:question="item"
								:editIndex="editIndex"
								:editOptionIndex="editOptionIndex"
								@wjaddquestionoption="wjaddquestionoption"
								@wjdelquestionoption="wjdelquestionoption"
								@addmatrixquestionsoption="addMatrixQuestionsOption"
								@questiondel="questiondel"
								@showAdvance="showAdvance"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@wjupdquestionoption="wjupdquestionoption"
								@wjupdoption="wjupdoption"
								@addquestionitem="addQuestionItem"
								@wjChangeBlank="wjChangeBlank"
							/>
							<!-- 多项填空 -->
							<QuestionMu
								v-model="value1"
								v-if="item.questionsTypeId == 35"
								:index="index"
								:question="item"
								:editIndex="editIndex"
								:editOptionIndex="editOptionIndex"
								@wjaddquestionoption="wjaddquestionoption"
								@wjdelquestionoption="wjdelquestionoption"
								@addmatrixquestionsoption="addMatrixQuestionsOption"
								@questiondel="questiondel"
								@showAdvance="showAdvance"
								@setEditIndex="setEditIndex"
								@setEditOptionIndex="setEditOptionIndex"
								@wjupdquestionoption="wjupdquestionoption"
								@wjupdoption="wjupdoption"
								@addquestionitem="addQuestionItem"
							/>
						</el-row>
					</el-main>
				</el-container>
			</div>
			<div v-if="selectIndex == 4">
				<!-- 答题设置 -->
				<div class="answer_set">
					<div>
						<p class="limit">
							<a></a>
							答题设置
						</p>
						<ul style="margin-top: 29px; width: 700px; background: #fff">
							<li class="button_line">
								<span>
									每个微信答题次数限制
									<i class="iconfont icon-bangzhu"></i>
								</span>
								<el-switch v-model="resultBody.wxLimit" :active-value="1" :inactive-value="0" @change="switchWxLimit(resultBody.wxLimit)" />
							</li>
							<li v-if="resultBody.wxLimit == 1" class="limit_num_box">
								<div class="limit_num">
									<div class="wx_limt">
										<el-select v-model="wxLimitFreq" placeholder="请选择" @change="wxLimit($event)">
											<el-option v-for="wxItem in wxLimitFreqOptions" :key="wxItem.value" :label="wxItem.label" :value="wxItem.value"></el-option>
										</el-select>
									</div>
									<div class="wx_limit_number">
										<span>答题</span>
										<el-input v-model="wxLimitNumber" placeholder="请输入内容" @blur="wxlimitInput"></el-input>
										<span>次</span>
									</div>
								</div>
							</li>
						</ul>
						<ul style="width: 700px; background: #fff">
							<li class="button_line">
								<span>
									每台电脑或手机答题次数限制
									<i class="iconfont icon-bangzhu"></i>
								</span>
								<el-switch v-model="resultBody.pcLimit" :active-value="1" :inactive-value="0" @change="switchPcLimit(resultBody.pcLimit)" />
							</li>
							<li v-if="resultBody.pcLimit == 1" class="limit_num_box">
								<div class="limit_num">
									<div class="wx_limt">
										<el-select v-model="pcLimitFreq" placeholder="请选择" @change="wxPcLimit($event)">
											<el-option v-for="wxItem in wxLimitFreqOptions" :key="wxItem.value" :label="wxItem.label" :value="wxItem.value"></el-option>
										</el-select>
									</div>
									<div class="wx_limit_number">
										<span>答题</span>
										<el-input v-model="pcLimitNumber" placeholder="请输入内容" @blur="wxPclimitInput"></el-input>
										<span>次</span>
									</div>
								</div>
							</li>
						</ul>
						<ul style="width: 700px; background: #fff">
							<li class="button_line">
								<span>
									每个IP答题次数限制
									<i class="iconfont icon-bangzhu"></i>
								</span>
								<el-switch v-model="resultBody.ipLimit" :active-value="1" :inactive-value="0" @change="switchpLimit(resultBody.ipLimit)" />
							</li>
							<li v-if="resultBody.ipLimit == 1" class="limit_num_box">
								<div class="limit_num">
									<div class="wx_limt">
										<el-select v-model="ipLimitFreq" placeholder="请选择" @change="wxIpLimit($event)">
											<el-option v-for="wxItem in wxLimitFreqOptions" :key="wxItem.value" :label="wxItem.label" :value="wxItem.value"></el-option>
										</el-select>
									</div>
									<div class="wx_limit_number">
										<span>答题</span>
										<el-input v-model="ipLimitNumber" placeholder="请输入内容" @blur="wxIplimitInput"></el-input>
										<span>次</span>
									</div>
								</div>
							</li>
						</ul>
						<ul style="width: 700px; background: #fff">
							<li class="button_line">
								<span>
									启动访问密码
									<i class="iconfont icon-bangzhu"></i>
								</span>
								<el-switch v-model="resultBody.startUpPassword" :active-value="1" :inactive-value="0" @change="switchStartUpPassword(resultBody.startUpPassword)" />
							</li>
							<li v-if="resultBody.startUpPassword == 1" class="limit_num_box">
								<div class="limit_num">
									<input
										type="text"
										v-model="startPasswordNumber"
										placeholder="请输入访问密码"
										style="
                      width: 180px;
                      height: 24px;
                      border: 1px solid #ccc !important;
                    "
									/>
									<span style="color: #0080ff; margin-left: 15px; font-size: 13px" @click="startPsSure(startPasswordNumber)">确定</span>
								</div>
							</li>
						</ul>
						<ul style="width: 700px; background: #fff">
							<li class="button_line">
								<span>限定手机号答题</span>
								<i class="el-icon-arrow-right" style="color: #ccc"></i>
							</li>
						</ul>
						<ul style="width: 700px; background: #fff">
							<li class="button_line">
								<span>
									只有被邀请的受访者可回答
									<i class="iconfont icon-bangzhu"></i>
								</span>
								<el-switch v-model="resultBody.onlyEmail" :active-value="1" :inactive-value="0" @change="switchOnlyEmail(resultBody.onlyEmail)" />
							</li>
						</ul>
						<ul style="width: 700px; background: #fff">
							<li class="button_line">
								<span>设置开始/结束时间</span>
								<el-switch v-model="resultBody.setStartEndTime" :active-value="1" :inactive-value="0" @change="switchSetStartEndTime(resultBody.setStartEndTime)" />
							</li>
							<li v-if="resultBody.setStartEndTime == 1" class="limit_num_box">
								<div class="setTimer_num">
									<div style="display: flex">
										<el-checkbox label="开始时间" @change="startTimer()"></el-checkbox>
										<div v-if="startTimerState">111</div>
									</div>
									<div><el-checkbox label="结束时间"></el-checkbox></div>
									<div><el-checkbox label="每天在指定时间段作答"></el-checkbox></div>
								</div>
							</li>
						</ul>
						<!--是否允许断点续答后期完善-->
						<!-- <ul style="width: 700px; background: #fff">
              <li class="button_line" style="border: none">
                <span>是否允许断点续答</span
                ><el-switch
                  v-model="resultBody.breakpointAnswer"
                  :active-value="1"
                  :inactive-value="0"
                  @change="switchBreakpointAnswer(resultBody.breakpointAnswer)"
                />
              </li>
              <li
                style="
                  margin-left: 20px;
                  font-family: MicrosoftYaHei;
                  font-size: 12px;
                  padding-bottom: 19px;
                "
              >
                填写者在填写过程中，可以关闭页面。下次打开可以继续上一次的作答进度继续答题
              </li>
            </ul>-->
					</div>
				</div>

				<!-- 微信设置 -->
				<div class="answer_set">
					<div>
						<p class="limit">
							<a></a>
							微信设置
						</p>
						<ul style="width: 700px; background: #fff; margin-top: 28px">
							<li class="button_line">
								<span>只能通过微信回答</span>
								<el-switch v-model="resultBody.onlyWx" :active-value="1" :inactive-value="0" @change="switchOnlyWx(resultBody.onlyWx)" />
							</li>
						</ul>
						<ul style="width: 700px; background: #fff">
							<li class="button_line" style="border: none">
								<span>
									记录微信用户个人信息
									<i class="iconfont icon-bangzhu"></i>
								</span>
								<el-switch v-model="resultBody.recordWxUser" :active-value="1" :inactive-value="0" @change="switchRecordWxUser(resultBody.recordWxUser)" />
							</li>
							<li
								style="
                  margin-left: 20px;
                  font-family: MicrosoftYaHei;
                  font-size: 12px;
                  padding-bottom: 19px;
                "
							>
								回答前需要答题者授权登录，提供微信昵称、性别、城市信息
							</li>
							<li v-if="resultBody.recordWxUser == 1" class="limit_num_box"><div class="limit_num">gggggggggg</div></li>
						</ul>
						<ul style="width: 700px; background: #fff">
							<li class="button_line">
								<span>自定义微信分享图标</span>
								<i class="el-icon-arrow-right" style="color: #ccc"></i>
							</li>
						</ul>
						<ul style="width: 700px; background: #fff">
							<li class="button_line" style="border: none">
								<span>
									禁止微信右上角分享
									<i class="iconfont icon-bangzhu"></i>
								</span>
								<el-switch v-model="resultBody.prohibitWXShare" :active-value="1" :inactive-value="0" @change="switchProhibitWXShare(resultBody.prohibitWXShare)" />
							</li>
						</ul>
					</div>
				</div>

				<!-- 提醒设置 -->
				<div class="answer_set">
					<div>
						<p class="limit">
							<a></a>
							提醒设置
						</p>
						<ul style="width: 700px; background: #fff; margin-top: 28px">
							<li class="button_line">
								<span>
									有新数据时，通过微信提醒我
									<i class="iconfont icon-bangzhu"></i>
								</span>
								<el-switch v-model="resultBody.newMsgtoWX" :active-value="1" :inactive-value="0" @change="switchNewMsgtoWX(resultBody.newMsgtoWX)" />
							</li>
							<li v-if="resultBody.newMsgtoWX == 1" class="limit_num_box"><div class="limit_num">ffffff</div></li>
						</ul>
						<ul style="width: 700px; background: #fff">
							<li class="button_line" style="border: none">
								<span>
									有新数据时，通过邮件提醒我
									<i class="iconfont icon-bangzhu"></i>
								</span>
								<el-switch v-model="resultBody.newMsgtoEmail" :active-value="1" :inactive-value="0" @change="switchNewMsgtoEmail(resultBody.newMsgtoEmail)" />
							</li>
							<li v-if="resultBody.newMsgtoEmail == 1" class="limit_num_box"><div class="limit_num">gggggggggg</div></li>
						</ul>
					</div>
				</div>

				<!-- 质量设置 -->
				<div class="answer_set">
					<div>
						<p class="limit">
							<a></a>
							质量设置
						</p>
						<ul style="width: 700px; background: #fff; margin-top: 28px">
							<li class="button_line">
								<span>设定答题数据上限</span>
								<el-switch
									v-model="resultBody.ifAnswerDataLimit"
									:active-value="1"
									:inactive-value="0"
									@change="switchIfAnswerDataLimit(resultBody.ifAnswerDataLimit)"
								/>
							</li>
							<li v-if="resultBody.ifAnswerDataLimit == 1" class="limit_num_box">
								<div class="limit_num" style="font-size: 13px">
									<span>收集</span>
									<input type="text" v-model="answerlimit" class="answerlimit" />
									<span>份数据时结束</span>
									<span style="color: #0080ff; margin-left: 18px" @click="answerLimit(answerlimit)">确定</span>
								</div>
							</li>
						</ul>
						<ul style="width: 700px; background: #fff">
							<li class="button_line">
								<span>控制页面填写时间</span>
								<el-switch v-model="resultBody.pageAnswerTime" :active-value="1" :inactive-value="0" @change="switchPageAnswerTime(resultBody.pageAnswerTime)" />
							</li>
							<li v-if="resultBody.pageAnswerTime == 1" class="limit_num_box">
								<div class="limit_num" style="font-size: 13px">
									<span>限制</span>
									<input type="text" v-model="answerNumber" class="answerlimit" />
									<span>分钟内完成考试 , 超时将所有内容自动提交</span>
									<span style="color: #0080ff; margin-left: 18px; cursor: pointer;" @click="answerNumbers(answerNumber)">确定</span>
								</div>
							</li>
						</ul>
						<ul style="width: 700px; background: #fff">
							<li class="button_line">
								<span>设置甄别页</span>
								<i class="el-icon-arrow-right" style="color: #ccc"></i>
							</li>
						</ul>
						<ul style="width: 700px; background: #fff">
							<li class="button_line">
								<span>设置配额</span>
								<i class="el-icon-arrow-right" style="color: #ccc"></i>
							</li>
						</ul>
						<ul style="width: 700px; background: #fff">
							<li class="button_line" style="border: none">
								<span>使用规则自动筛选无效答卷</span>
								<i class="el-icon-arrow-right" style="color: #ccc"></i>
							</li>
						</ul>
					</div>
				</div>

				<!-- 公开设置 -->
				<div class="answer_set">
					<div>
						<p class="limit">
							<a></a>
							公开设置
						</p>
						<ul style="width: 700px; background: #fff; margin-top: 28px">
							<li class="button_line">
								<span>是否允许受访人查看统计</span>
								<el-switch
									v-model="resultBody.ifAllowStatistics"
									:active-value="1"
									:inactive-value="0"
									@change="switchIfAllowStatistics(resultBody.ifAllowStatistics)"
								/>
							</li>
						</ul>
						<ul style="width: 700px; background: #fff">
							<li class="button_line" style="border: none">
								<span>显示“分享”按钮，可分享链接至更多社交网站(仅电脑答题页)</span>
								<el-switch v-model="resultBody.ifDisplayShare" :active-value="1" :inactive-value="0" @change="switchIfDisplayShare(resultBody.ifDisplayShare)" />
							</li>
						</ul>
					</div>
				</div>

				<!-- 奖品及红包 -->
				<div class="answer_set">
					<div>
						<p class="limit">
							<a></a>
							奖品及红包
						</p>
						<ul style="width: 700px; background: #fff; margin-top: 28px">
							<li class="button_line">
								<span>微信红包</span>
								<i class="el-icon-arrow-right" style="color: #ccc"></i>
							</li>
						</ul>
						<ul style="width: 700px; background: #fff">
							<li class="button_line" style="border: none">
								<span>自定义抽奖</span>
								<i class="el-icon-arrow-right" style="color: #ccc"></i>
							</li>
						</ul>
					</div>
				</div>

				<!-- 其他设置 -->
				<div class="answer_set">
					<div>
						<p class="limit">
							<a></a>
							其他设置
						</p>
						<ul style="width: 700px; background: #fff; margin-top: 28px">
							<li class="button_line">
								<span>答题完成后自定义跳转</span>
								<el-switch v-model="resultBody.customJump" :active-value="1" :inactive-value="0" @change="switchCustomJump(resultBody.customJump)" />
							</li>
							<li v-if="resultBody.customJump == 1" class="limit_num_box"><div class="limit_num">qqqqqqqqq</div></li>
						</ul>
						<ul style="width: 700px; background: #fff">
							<li class="button_line" style="border: none">
								<span>
									允许搜索引擎检索项目内容
									<i class="iconfont icon-bangzhu"></i>
								</span>
								<el-switch v-model="resultBody.shareSeoIndex" :active-value="1" :inactive-value="0" @change="switchShareSeoIndex(resultBody.shareSeoIndex)" />
							</li>
							<li
								style="
                  margin-left: 20px;
                  font-family: MicrosoftYaHei;
                  font-size: 12px;
                  padding-bottom: 19px;
                "
							>
								关闭此功能时如搜索引擎已经检索，需自行投诉快照进行删除
							</li>
						</ul>
						<ul style="width: 700px; background: #fff">
							<li class="button_line" style="border: none">
								<span>
									允许搜索引擎检索项目内容
									<i class="iconfont icon-bangzhu"></i>
								</span>
								<el-switch v-model="resultBody.hideLogo" :active-value="1" :inactive-value="0" @change="switchHideLogo(resultBody.hideLogo)" />
							</li>
						</ul>
					</div>
				</div>

				<!-- 电访设置 -->
				<div class="answer_set">
					<div>
						<p class="limit">
							<a></a>
							电访设置
						</p>
						<ul style="width: 700px; background: #fff; margin-top: 28px">
							<li class="button_line" style="border: none"><span>请等待我们的升级版本……</span></li>
						</ul>
					</div>
				</div>
			</div>
		</div>

		<div class="wjType" :style="{ height: rightheight + 'px' }" style="overflow-y: auto; background: #fff">
			<div v-if="editIndex != -1" style="width: 100%; height: 45rem; margin-top: 2px; overflow-y: auto" class="display_inline">
				<el-divider></el-divider>
				<div class="operate_item">
					<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
						<span class="left" style="font-weight: bold">Q:{{ editIndex + 1 }}题目设置</span>
					</el-col>
					<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" style="text-align: right"></el-col>
				</div>
				<div class="operate_item" style="border-bottom: 1px solid #ccc">
					<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12"><span class="left">整题设置</span></el-col>
				</div>
				<!-- 手机号 -->
				<div v-if="questionsTypeId == 2" style="width: 90%; margin: 0 auto">
					<div class="heiSetting">
						<span class="left">此题必答</span>
						<span class="right"><el-switch v-model="ifMustAnswer" :active-value="1" :inactive-value="0" @change="mustAnswer(switchID, ifMustAnswer)"></el-switch></span>
					</div>
					<div
						class="heiSetting"
						style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
					>
						<span class="left">输入框大小</span>
						<div class="right tab_layout input_size w-btn-group">
							<span :class="{ activeCheck: currentSort == 0 }" @click="setInputSize(0, switchID)">小</span>
							<span :class="{ activeCheck: currentSort == 1 }" @click="setInputSize(1, switchID)">中</span>
							<span :class="{ activeCheck: currentSort == 2 }" @click="setInputSize(2, switchID)">大</span>
						</div>
					</div>
					<div class="heiSetting">
						<span class="left">
							逻辑设置
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right" style="color: #0080ff"><a>设置</a></span>
					</div>
					<div class="heiSetting">
						<span class="left">内容限制</span>
						<span class="right">
							<el-select v-model="content.ContentRes" placeholder="请选择" @change="contents(content.ContentRes, switchID)">
								<el-option v-for="item in ContentRestrictions" :key="item.label" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</span>
					</div>
				</div>
				<!-- 单行输入框 -->
				<div v-if="questionsTypeId == 3" style="width: 90%; margin: 0 auto">
					<div class="heiSetting">
						<span class="left">此题必答</span>
						<span class="right"><el-switch v-model="ifMustAnswer" :active-value="1" :inactive-value="0" @change="mustAnswer(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">输入框大小</span>
						<div class="right tab_layout input_size w-btn-group">
							<span :class="{ activeCheck: currentSort == 0 }" @click="setInputSize(0, switchID)">小</span>
							<span :class="{ activeCheck: currentSort == 1 }" @click="setInputSize(1, switchID)">中</span>
							<span :class="{ activeCheck: currentSort == 2 }" @click="setInputSize(2, switchID)">大</span>
						</div>
					</div>
					<div class="heiSetting">
						<span class="left">
							逻辑设置
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right">设置</span>
					</div>
					<div class="heiSetting">
						<span class="left">内容限制</span>
						<span class="right">
							<el-select v-model="content.lineInput" placeholder="请选择" @change="contents(content.lineInput, switchID)">
								<el-option v-for="item in ContentRestrictions" :key="item.label" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</span>
					</div>
					<div class="heiSetting">
						<span class="left">字数限制</span>
						<div class="right" style="font-size: 14px">
							<span class="heade" @click="startnum--">-</span>
							<span class="numLimit">{{ startnum }}</span>
							<span class="heade" @click="startnum++">+</span>
							<span style="margin: 0 5px">至</span>
							<span class="heade" @click="endnum--">-</span>
							<span class="numLimit">{{ endnum }}</span>
							<span class="heade" @click="endnum++">+</span>
						</div>
					</div>
					<div class="heiSetting">
						<span class="left">题型切换</span>
						<div class="right tab_layout input_size w-btn-group">
							<span :class="{ activeCheck: questionlineRank == 0 }" @click="switchoverType(0, switchID)">单行</span>
							<span :class="{ activeCheck: questionlineRank == 1 }" @click="switchoverType(1, switchID)">多行</span>
						</div>
					</div>
				</div>
				<!-- 多行输入框 -->
				<div v-if="questionsTypeId == 4" style="width: 90%; margin: 0 auto">
					<div class="heiSetting">
						<span class="left">此题必答</span>
						<span class="right"><el-switch v-model="ifMustAnswer" :active-value="1" :inactive-value="0" @change="mustAnswer(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">输入框大小</span>
						<div class="right tab_layout input_size w-btn-group">
							<span :class="{ activeCheck: currentSort == 0 }" @click="setInputSize(0, switchID)">小</span>
							<span :class="{ activeCheck: currentSort == 1 }" @click="setInputSize(1, switchID)">中</span>
							<span :class="{ activeCheck: currentSort == 2 }" @click="setInputSize(2, switchID)">大</span>
						</div>
					</div>
					<div class="heiSetting">
						<span class="left">
							逻辑设置
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right">设置</span>
					</div>
					<div class="heiSetting">
						<span class="left">内容限制</span>
						<span class="right">
							<el-select v-model="content.multiline" placeholder="请选择" @change="contents(content.multiline, switchID)">
								<el-option v-for="item in ContentRestrictions" :key="item.label" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</span>
					</div>
					<div class="heiSetting">
						<span class="left">字数限制</span>
						<div class="right" style="font-size: 14px">
							<span class="heade" @click="startnum--">-</span>
							<span class="numLimit">{{ startnum }}</span>
							<span class="heade" @click="startnum++">+</span>
							<span style="margin: 0 5px">至</span>
							<span class="heade" @click="endnum--">-</span>
							<span class="numLimit">{{ endnum }}</span>
							<span class="heade" @click="endnum++">+</span>
						</div>
					</div>
					<div class="heiSetting">
						<span class="left">题型切换</span>
						<div class="right tab_layout input_size w-btn-group">
							<span :class="{ activeCheck: questionlineRank == 0 }" @click="switchoverType(0, switchID)">单行</span>
							<span :class="{ activeCheck: questionlineRank == 1 }" @click="switchoverType(1, switchID)">多行</span>
						</div>
					</div>
				</div>
				<!-- 填空题 -->
				<div v-if="questionsTypeId == 5" style="width: 90%; margin: 0 auto">
					<div class="heiSetting">
						<span class="left">此题必答</span>
						<span class="right"><el-switch v-model="ifMustAnswer" :active-value="1" :inactive-value="0" @change="mustAnswer(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">输入框大小</span>
						<div class="right tab_layout input_size w-btn-group">
							<div class="right tab_layout input_size w-btn-group">
								<span :class="{ activeCheck: currentSort == 0 }" @click="setInputSize(0, switchID)">小</span>
								<span :class="{ activeCheck: currentSort == 1 }" @click="setInputSize(1, switchID)">中</span>
								<span :class="{ activeCheck: currentSort == 2 }" @click="setInputSize(2, switchID)">大</span>
							</div>
						</div>
					</div>
					<div class="heiSetting">
						<span class="left">
							逻辑设置
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right">设置</span>
					</div>
					<p
						style="
              height: 60px;
              line-height: 60px;
              border-bottom: 1px solid #ccc;
            "
					>
						填写限制
					</p>
					<div class="heiSetting">
						<span class="left">内容限制</span>
						<span class="right">
							<el-select v-model="content.gapFil" placeholder="请选择" @change="contents(content.gapFil, switchID)">
								<el-option v-for="item in ContentRestrictions" :key="item.label" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</span>
					</div>
					<div class="heiSetting">
						<span class="left">最少填写</span>
						<div class="right" style="display: flex">
							<el-input v-model="inputLeast" @change="inpLeast(inputLeast, switchID)"></el-input>
							<a style="margin-left: 4px">字</a>
						</div>
					</div>
					<div class="heiSetting">
						<span class="left">最多填写</span>
						<div class="right" style="display: flex">
							<el-input v-model="inputMoster" @change="inpMoster(inputMoster, switchID)"></el-input>
							<a style="margin-left: 4px">字</a>
						</div>
					</div>
				</div>
				<!-- 图片选择  -->
				<!-- 未完成  -->
				<div v-if="questionsTypeId == 6">
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">此题必答</span>
						<span class="right"><el-switch v-model="ifMustAnswer" :active-value="1" :inactive-value="0" @change="mustAnswer(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">题型</span>
						<div class="right tab_layout">
							<span :class="{ activeCheck: questionsType == 1 }" @click="setTopic(1, switchID)">单选</span>
							<span :class="{ activeCheck: questionsType == 2 }" @click="setTopic(2, switchID)">多选</span>
						</div>
					</div>
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">
							逻辑设置
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right">设置</span>
					</div>
					<p
						style="
              height: 60px;
              line-height: 60px;
              border-bottom: 1px solid #ccc;
              width: 90%;
              margin: 0 auto;
            "
					>
						选项设置
					</p>
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">选项随机排列</span>
						<span class="right"><el-switch v-model="optionIfRandom" :active-value="1" :inactive-value="0" @change="RandomArr(switchID)"></el-switch></span>
					</div>
					<div v-if="optionIfRandom == 1" style="width: 343px; height: 50px; background: #fafafa">
						<div class="heiSetting" style="width: 90%; margin: 0 auto">
							<span class="left">固定最后一个选项</span>
							<span class="right"><el-switch v-model="ifFixedLastOption" :active-value="1" :inactive-value="0" @change="fixation(switchID)"></el-switch></span>
						</div>
					</div>
				</div>
				<!-- 单选题 -->
				<div v-if="questionsTypeId == 8">
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">此题必答</span>
						<span class="right"><el-switch v-model="ifMustAnswer" :active-value="1" :inactive-value="0" @change="mustAnswer(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">题型</span>
						<div class="right tab_layout">
							<span :class="{ activeCheck: questionsType == 1 }" @click="setTopic(1, switchID)">单选</span>
							<span :class="{ activeCheck: questionsType == 2 }" @click="setTopic(2, switchID)">多选</span>
						</div>
					</div>
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">
							逻辑设置
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right">设置</span>
					</div>
					<p
						style="
              height: 60px;
              line-height: 60px;
              border-bottom: 1px solid #ccc;
              width: 90%;
              margin: 0 auto;
            "
					>
						选项设置
					</p>
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">
							分组
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right">设置</span>
					</div>
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">选项随机排列</span>
						<span class="right"><el-switch v-model="optionIfRandom" :active-value="1" :inactive-value="0" @change="RandomArr(switchID)"></el-switch></span>
					</div>
					<div v-if="optionIfRandom == 1" style="width: 343px; height: 100px; background: #fafafa">
						<div class="heiSetting" style="width: 90%; margin: 0 auto">
							<span class="left">
								组内随机
								<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
							</span>
							<span class="right"><el-switch v-model="inGroupRandom" :active-value="1" :inactive-value="0" @change="inGroupR(switchID)"></el-switch></span>
						</div>
						<div class="heiSetting" style="width: 90%; margin: 0 auto">
							<span class="left">
								组间随机
								<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
							</span>
							<span class="right"><el-switch v-model="betweenGroupRandom" :active-value="1" :inactive-value="0" @change="betRan(switchID)"></el-switch></span>
						</div>
					</div>
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">选项布局</span>
						<div class="right tab_layout">
							<span :class="{ activeCheck: questionLayout == 1 }" @click="setLayout(1, switchID)">单列</span>
							<span :class="{ activeCheck: questionLayout == 2 }" @click="setLayout(2, switchID)">2列</span>
							<span :class="{ activeCheck: questionLayout == 3 }" @click="setLayout(3, switchID)">3列</span>
						</div>
					</div>
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">选项关联</span>
						<span class="right">设置</span>
					</div>
				</div>
				<!-- 下拉框 -->
				<div v-if="questionsTypeId == 9">
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">此题必答</span>
						<span class="right"><el-switch v-model="ifMustAnswer" :active-value="1" :inactive-value="0" @change="mustAnswer(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">题型</span>
						<div class="right tab_layout">
							<span :class="{ activeCheck: questionsType == 1 }" @click="setTopic(1, switchID)">单选</span>
							<span :class="{ activeCheck: questionsType == 2 }" @click="setTopic(2, switchID)">多选</span>
						</div>
					</div>
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">
							逻辑设置
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right"><a>设置</a></span>
					</div>
					<p
						style="
              height: 60px;
              line-height: 60px;
              border-bottom: 1px solid #ccc;
              width: 90%;
              margin: 0 auto;
            "
					>
						选项设置
					</p>
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">选项随机排列</span>
						<span class="right"><el-switch v-model="optionIfRandom" :active-value="1" :inactive-value="0" @change="RandomArr(switchID)"></el-switch></span>
					</div>
					<div v-if="optionIfRandom == 1" style="width: 343px; height: 100px; background: #fafafa">
						<div class="heiSetting" style="width: 90%; margin: 0 auto">
							<span class="left">
								组内随机
								<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
							</span>
							<span class="right"><el-switch v-model="inGroupRandom" :active-value="1" :inactive-value="0" @change="inGroupR(switchID)"></el-switch></span>
						</div>
						<div class="heiSetting" style="width: 90%; margin: 0 auto">
							<span class="left">
								组间随机
								<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
							</span>
							<span class="right"><el-switch v-model="betweenGroupRandom" :active-value="1" :inactive-value="0" @change="betRan(switchID)"></el-switch></span>
						</div>
					</div>
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">
							选项关联
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right">设置</span>
					</div>
				</div>
				<!-- 多选题 -->
				<div v-if="questionsTypeId == 10">
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">此题必答</span>
						<span class="right"><el-switch v-model="ifMustAnswer" :active-value="1" :inactive-value="0" @change="mustAnswer(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">题型</span>
						<div class="right tab_layout">
							<span :class="{ activeCheck: questionsType == 1 }" @click="setTopic(1, switchID)">单选</span>
							<span :class="{ activeCheck: questionsType == 2 }" @click="setTopic(2, switchID)">多选</span>
						</div>
					</div>
					<div
						style="
              height: 80px;
              border-bottom: 1px solid #ccc;
              width: 90%;
              margin: 0 auto;
            "
					>
						<span class="left" style="width: 100%; height: 40px; line-height: 50px">可选范围</span>
						<!-- <br> -->
						<div style="width: 100%; height: 40px; line-height: 20px">
							<div style="float: left; margin-left: 10px"><span>最少</span></div>
							<div style="float: left"><span>最多</span></div>
						</div>
					</div>
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">
							逻辑设置
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right"><a>设置</a></span>
					</div>
					<p
						style="
              height: 60px;
              line-height: 60px;
              border-bottom: 1px solid #ccc;
              width: 90%;
              margin: 0 auto;
            "
					>
						选项设置
					</p>
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">
							分组
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right">设置</span>
					</div>
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">选项随机排列</span>
						<span class="right"><el-switch v-model="optionIfRandom" :active-value="1" :inactive-value="0" @change="RandomArr(switchID)"></el-switch></span>
					</div>
					<div v-if="optionIfRandom == 1" style="width: 343px; height: 100px; background: #fafafa">
						<div class="heiSetting" style="width: 90%; margin: 0 auto">
							<span class="left">
								组内随机
								<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
							</span>
							<span class="right"><el-switch v-model="inGroupRandom" :active-value="1" :inactive-value="0" @change="inGroupR(switchID)"></el-switch></span>
						</div>
						<div class="heiSetting" style="width: 90%; margin: 0 auto">
							<span class="left">
								组间随机
								<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
							</span>
							<span class="right"><el-switch v-model="betweenGroupRandom" :active-value="1" :inactive-value="0" @change="betRan(switchID)"></el-switch></span>
						</div>
					</div>
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">选项布局</span>
						<div class="right tab_layout">
							<span :class="{ activeCheck: questionLayout == 1 }" @click="setLayout(1, switchID)">单列</span>
							<span :class="{ activeCheck: questionLayout == 2 }" @click="setLayout(2, switchID)">1列</span>
							<span :class="{ activeCheck: questionLayout == 3 }" @click="setLayout(3, switchID)">2列</span>
						</div>
					</div>
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">
							选项关联
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right">设置</span>
					</div>
				</div>
				<!-- 星级评分 -->
				<!-- 未写 -->
				<div v-if="questionsTypeId == 11" style="width: 90%; margin: 0 auto">
					<div class="heiSetting">
						<span class="left">此题必答</span>
						<span class="right"><el-switch v-model="ifMustAnswer" :active-value="1" :inactive-value="0" @change="mustAnswer(switchID)"></el-switch></span>
					</div>
				</div>
				<!-- 判断题 -->
				<div v-if="questionsTypeId == 12" style="width: 90%; margin: 0 auto">
					<div class="heiSetting">
						<span class="left">此题必答</span>
						<span class="right"><el-switch v-model="ifMustAnswer" :active-value="1" :inactive-value="0" @change="mustAnswer(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">
							逻辑设置
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right">设置</span>
					</div>
				</div>
				<!-- 日期选择 -->
				<div v-if="questionsTypeId == 13" style="width: 90%; margin: 0 auto">
					<div class="heiSetting">
						<span class="left">此题必答</span>
						<span class="right"><el-switch v-model="ifMustAnswer" :active-value="1" :inactive-value="0" @change="mustAnswer(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">
							逻辑设置
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right">设置</span>
					</div>
				</div>
				<!-- 排序题 -->
				<div v-if="questionsTypeId == 14">
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">此题必答</span>
						<span class="right"><el-switch v-model="ifMustAnswer" :active-value="1" :inactive-value="0" @change="mustAnswer(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">
							逻辑设置
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right">设置</span>
					</div>
					<p
						style="
              height: 60px;
              line-height: 60px;
              border-bottom: 1px solid #ccc;
              width: 90%;
              margin: 0 auto;
            "
					>
						选项设置
					</p>
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">选项随机排列</span>
						<span class="right"><el-switch v-model="optionIfRandom" :active-value="1" :inactive-value="0" @change="RandomArr(switchID)"></el-switch></span>
					</div>
					<div v-if="optionIfRandom == 1" style="width: 343px; height: 100px; background: #fafafa">
						<div class="heiSetting" style="width: 90%; margin: 0 auto">
							<span class="left">
								组内随机
								<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
							</span>
							<span class="right"><el-switch v-model="inGroupRandom" :active-value="1" :inactive-value="0" @change="inGroupR(switchID)"></el-switch></span>
						</div>
						<div class="heiSetting" style="width: 90%; margin: 0 auto">
							<span class="left">
								组间随机
								<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
							</span>
							<span class="right"><el-switch v-model="betweenGroupRandom" :active-value="1" :inactive-value="0" @change="betRan(switchID)"></el-switch></span>
						</div>
					</div>
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">仅选出</span>
						<div class="right">
							<el-select v-model="choice.sortsnums" placeholder="请选择" @change="choiceNum(choice.sortsnums, switchID)">
								<el-option v-for="item in choiceContent" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
							位
						</div>
					</div>
				</div>
				<!-- 地址位置 -->
				<div v-if="questionsTypeId == 15" style="width: 90%; margin: 0 auto">
					<div class="heiSetting">
						<span class="left">此题必答</span>
						<span class="right"><el-switch v-model="ifMustAnswer" :active-value="1" :inactive-value="0" @change="mustAnswer(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">自动定位</span>
						<span class="right"><el-switch v-model="manualSetting" :active-value="1" :inactive-value="0" @change="manSet(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">
							逻辑设置
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right">设置</span>
					</div>
				</div>
				<!-- 城市选择 -->
				<div v-if="questionsTypeId == 16" style="width: 90%; margin: 0 auto">
					<div class="heiSetting">
						<span class="left">此题必答</span>
						<span class="right"><el-switch v-model="ifMustAnswer" :active-value="1" :inactive-value="0" @change="mustAnswer(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">
							逻辑设置
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right">设置</span>
					</div>
					<p
						style="
              height: 60px;
              line-height: 60px;
              border-bottom: 1px solid #ccc;
            "
					>
						选项设置
					</p>
					<div style="font-size: 14px">
						<span>详细程度</span>
						<div v-for="(itemChoice, indexChoice) in cityChoice" :key="indexChoice">
							<el-radio v-model="radioChoice" :label="itemChoice.value" @change="setDetails(switchID, itemChoice)">{{ itemChoice.label }}</el-radio>
						</div>
					</div>
				</div>
				<!-- 时间选择 -->
				<div v-if="questionsTypeId == 17" style="width: 90%; margin: 0 auto">
					<div class="heiSetting">
						<span class="left">此题必答</span>
						<span class="right"><el-switch v-model="ifMustAnswer" :active-value="1" :inactive-value="0" @change="mustAnswer(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">
							逻辑设置
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right">设置</span>
					</div>
				</div>
				
				<!-- 矩阵单选 -->
				<div v-if="questionsTypeId == 19" style="width: 90%; margin: 0 auto">
					<div class="heiSetting">
						<span class="left">此题必答</span>
						<span class="right"><el-switch v-model="ifMustAnswer" :active-value="1" :inactive-value="0" @change="mustAnswer(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">题型</span>
						<div class="right tab_layout">
							<span :class="{ activeCheck: questionsType == 1 }" @click="setTopic(1, switchID)">单选</span>
							<span :class="{ activeCheck: questionsType == 2 }" @click="setTopic(2, switchID)">多选</span>
						</div>
					</div>
					<div class="heiSetting">
						<span class="left">「行」随机排列</span>
						<span class="right"><el-switch v-model="matrixLineRandom" :active-value="1" :inactive-value="0" @change="lineMartix(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">「列」随机排列</span>
						<span class="right"><el-switch v-model="matrixRankRandom" :active-value="1" :inactive-value="0" @change="RankMartix(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">矩阵行列交换</span>
						<span class="right"><el-switch v-model="lineRankExchange" :active-value="1" :inactive-value="0" @change="lineRank(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">
							逻辑设置
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right">设置</span>
					</div>
				</div>
				<!-- 矩阵多选 -->
				<div v-if="questionsTypeId == 20" style="width: 90%; margin: 0 auto">
					<div class="heiSetting">
						<span class="left">此题必答</span>
						<span class="right"><el-switch v-model="ifMustAnswer" :active-value="1" :inactive-value="0" @change="mustAnswer(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">题型</span>
						<div class="right tab_layout">
							<span :class="{ activeCheck: questionsType == 1 }" @click="setTopic(1, switchID)">单选</span>
							<span :class="{ activeCheck: questionsType == 2 }" @click="setTopic(2, switchID)">多选</span>
						</div>
					</div>
					<div style="height: 90px; border-bottom: 1px solid #ccc"></div>
					<div class="heiSetting">
						<span class="left">「行」随机排列</span>
						<span class="right"><el-switch v-model="matrixLineRandom" :active-value="1" :inactive-value="0" @change="lineMartix(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">「列」随机排列</span>
						<span class="right"><el-switch v-model="matrixRankRandom" :active-value="1" :inactive-value="0" @change="RankMartix(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">矩阵行列交换</span>
						<span class="right"><el-switch v-model="lineRankExchange" :active-value="1" :inactive-value="0" @change="lineRank(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">
							逻辑设置
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right">设置</span>
					</div>
				</div>
				<!-- 矩阵星级评分 -->
				<div v-if="questionsTypeId == 21" style="width: 90%; margin: 0 auto">
					<div class="heiSetting">
						<span class="left">此题必答</span>
						<span class="right"><el-switch v-model="ifMustAnswer" :active-value="1" :inactive-value="0" @change="mustAnswer(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">「行」随机排列</span>
						<span class="right"><el-switch v-model="matrixLineRandom" :active-value="1" :inactive-value="0" @change="lineMartix(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">「列」随机排列</span>
						<span class="right"><el-switch v-model="matrixRankRandom" :active-value="1" :inactive-value="0" @change="RankMartix(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">矩阵行列交换</span>
						<span class="right"><el-switch v-model="lineRankExchange" :active-value="1" :inactive-value="0" @change="lineRank(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">
							逻辑设置
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right">设置</span>
					</div>
				</div>
				<div v-if="questionsTypeId == 22" style="width: 90%; margin: 0 auto">
					<div class="heiSetting">
						<span class="left">此题必答</span>
						<span class="right"><el-switch v-model="ifMustAnswer" :active-value="1" :inactive-value="0" @change="mustAnswer(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">「行」随机排列</span>
						<span class="right"><el-switch v-model="matrixLineRandom" :active-value="1" :inactive-value="0" @change="lineMartix(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">「列」随机排列</span>
						<span class="right"><el-switch v-model="matrixRankRandom" :active-value="1" :inactive-value="0" @change="RankMartix(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">矩阵行列交换</span>
						<span class="right"><el-switch v-model="lineRankExchange" :active-value="1" :inactive-value="0" @change="lineRank(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">
							逻辑设置
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right">设置</span>
					</div>
				</div>
				<div v-if="questionsTypeId == 25" style="width: 90%; margin: 0 auto">
					<div class="heiSetting">
						<span class="left">
							逻辑设置
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right">设置</span>
					</div>
				</div>
				<div v-if="questionsTypeId == 26" style="width: 90%; margin: 0 auto">
					<div class="heiSetting">
						<span class="left">此题必答</span>
						<span class="right"><el-switch v-model="ifMustAnswer" :active-value="1" :inactive-value="0" @change="mustAnswer(switchID)"></el-switch></span>
					</div>
				</div>
				<!-- 文件上传 -->
				<div v-if="questionsTypeId == 33" style="width: 90%; margin: 0 auto">
					<div class="heiSetting">
						<span class="left">此题必答</span>
						<span class="right"><el-switch v-model="ifMustAnswer" :active-value="1" :inactive-value="0" @change="mustAnswer(switchID)"></el-switch></span>
					</div>
				</div>
				<!-- 横向填空 -->
				<div v-if="questionsTypeId == 34" style="width: 90%; margin: 0 auto">
					<div class="heiSetting">
						<span class="left">此题必答</span>
						<span class="right"><el-switch v-model="ifMustAnswer" :active-value="1" :inactive-value="0" @change="mustAnswer(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting">
						<span class="left">
							逻辑设置
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right"><a>设置</a></span>
					</div>
					<p
						style="
              height: 60px;
              line-height: 60px;
              border-bottom: 1px solid #ccc;
            "
					>
						填空属性
					</p>
					<div class="heiSetting">
						<span class="left">填空属性</span>
						<span class="right">设置</span>
					</div>
				</div>
				<!-- 多项填空 -->
				<div v-if="questionsTypeId == 35">
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">此题必答</span>
						<span class="right"><el-switch v-model="ifMustAnswer" :active-value="1" :inactive-value="0" @change="mustAnswer(switchID)"></el-switch></span>
					</div>
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">
							逻辑设置
							<i class="el-icon-question" style="width: 24px; height: 24px; color: #ccc"></i>
						</span>
						<span class="right"></span>
					</div>
					<p
						style="
              height: 60px;
              line-height: 60px;
              border-bottom: 1px solid #ccc;
              width: 90%;
              margin: 0 auto;
            "
					>
						选项设置
					</p>
					<div class="heiSetting" style="width: 90%; margin: 0 auto">
						<span class="left">选项随机排列</span>
						<span class="right"><el-switch v-model="optionIfRandom" :active-value="1" :inactive-value="0" @change="RandomArr(switchID)"></el-switch></span>
					</div>
					<div v-if="optionIfRandom == 1" style="width: 343px; height: 50px; background: #fafafa">
						<div class="heiSetting" style="width: 90%; margin: 0 auto">
							<span class="left">固定最后一个选项</span>
							<span class="right"><el-switch v-model="ifFixedLastOption" :active-value="1" :inactive-value="0" @change="fixation(switchID)"></el-switch></span>
						</div>
					</div>
				</div>
				<!-- <div class="operate_item" >
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                            <span class="left">此题必答</span>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" style="text-align:right;">
                            <el-switch @change="setting_ismust()"
                                       v-model="ifMustAnswer">
                            </el-switch>
                        </el-col>
                    </div> -->
				<!-- <div class="operate_item" style="display: none;">
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                            <span class="left">题型</span>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" style="text-align:right;">
                            <el-radio-group v-model="ifMustSingle" size="mini">
                                <el-radio-button label="单选"></el-radio-button>
                                <el-radio-button label="多选"></el-radio-button>
                            </el-radio-group>
                        </el-col>
                    </div>
                    <el-divider></el-divider>
                    <div class="operate_item">
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                            <span class="left">逻辑设置</span>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" style="text-align:right;cursor: pointer;">
                            <span @click="logicSetting()">设置</span>
                        </el-col>
                    </div> -->
				<!-- <el-divider></el-divider> -->

				<!-- <div class="operate_item">
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                            <span class="left" style="font-weight: bold;">选项设置</span>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" style="text-align:right;">

                        </el-col>
                    </div>
                    <div class="operate_item" style="display: none;">
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                            <span class="left">选项分组</span>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" style="text-align:right;">
                            设置
                        </el-col>
                    </div> -->
				<!-- <el-divider></el-divider> -->

				<!-- <div class="operate_item">
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                            <span class="left">选项随机排列</span>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" style="text-align:right;">
                            <el-switch @change="setting_israndom()"
                                       v-model="optionIfRandom">
                            </el-switch>
                        </el-col>
                    </div>
                    <el-divider></el-divider>
                    <div class="operate_item" style="display: none;">
                        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                            <span class="left">选项布局</span>
                        </el-col>
                        <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" style="text-align:right;">
                            <el-radio-group v-model="choiceLayout" size="mini">
                                <el-radio-button label="单列"></el-radio-button>
                                <el-radio-button label="2列"></el-radio-button>
                                <el-radio-button label="3列"></el-radio-button>
                            </el-radio-group>
                        </el-col>
                    </div>
                </div> -->
			</div>
		</div>
		<el-dialog :title="`题库【${curTkType.questionnaireTypeName}】`" :visible.sync="centerDialogVisible" width="30%" center :close-on-click-modal="false">
			<el-table :data="tkList">
				<el-table-column property="questionsName" label="问题"></el-table-column>
				<el-table-column label="操作" width="100">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click="addTkItem(scope.row)">添加</el-button>
					</template>
				</el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer"><el-button size="medium" @click="centerDialogVisible = false">取 消</el-button></span>
		</el-dialog>

		<!-- <el-dialog title="设置" :visible.sync="settingDialog">
            <el-tabs v-model="activeName">
                <el-tab-pane label="逻辑设置" name="first">
                    共 {{datas_logic.length}} 条跳转逻辑
                    <table id="jump_table" class="jump_single_table">
                        <tbody v-if="datas_logic.length">
                        <tr class="jumpconstraint" v-for="(item,index) in datas_logic" :key="index">
                            <td>如果本题选中</td>
                            <td>
                                <select name="option_id" class="option_select">
                                    <option value="">请选择选项</option>
                                    <option value="any">任意选项</option>
                                </select>
                            </td>
                            <td style="text-align:center">则跳转到</td>
                            <td>
                                <select name="jump_to_qid">
                                    <option>请选择题目</option>
                                    <option>Q3. 请给以下选项投票</option>
                                </select>
                            </td>
                            <td>
                                <i class="el-icon-remove" style="font-size: 24px;" @click="remove_logic(index)"></i>
                            </td>
                        </tr>
                        <tr class="jumpconstraint">
                            <td>如果本题选中</td>
                            <td>
                                <select name="option_id" class="option_select">
                                    <option value="">请选择选项</option>
                                    <option value="any">任意选项</option>
                                </select>
                            </td>
                            <td style="text-align:center">则跳转到</td>
                            <td>
                                <select name="jump_to_qid">
                                    <option>请选择题目</option>
                                    <option>Q3. 请给以下选项投票</option>
                                </select>
                            </td>
                            <td>
                                <i class="el-icon-circle-plus" style="font-size: 24px;" @click="add_logic()"></i>
                            </td>
                        </tr>
                        </tbody>
                        <tbody v-if="!datas_logic.length">
                        <tr class="jumpconstraint">
                            <td>如果本题选中</td>
                            <td>
                                <select name="option_id" class="option_select">
                                    <option value="">请选择选项</option>
                                    <option value="any">任意选项</option>
                                </select>
                            </td>
                            <td style="text-align:center">则跳转到</td>
                            <td>
                                <select name="jump_to_qid">
                                    <option>请选择题目</option>
                                    <option>Q3. 请给以下选项投票</option>
                                </select>
                            </td>
                            <td>
                                <i class="el-icon-circle-plus" style="font-size: 24px;" @click="add_logic()"></i>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </el-tab-pane>
                <el-tab-pane label="显示设置" name="second">
                    共 {{datas_show.length}} 条显示逻辑,符合以下
                    <select name="option_id" class="option_select">
                        <option value="">全部</option>
                        <option value="any">任意</option>
                    </select><br/>
                    选项时，显示。
                    <tbody v-if="datas_show.length">
                    <tr class="jumpconstraint" v-for="(item,index) in datas_show" :key="index">
                        <td>
                            <select name="option_id" class="option_select">
                                <option value="">请选择选项</option>
                                <option value="any">任意选项</option>
                            </select>
                        </td>
                        <td>
                            <select name="option_id" class="option_select">
                                <option value="">请选择条件</option>
                                <option value="any">选中</option>
                                <option value="any">未选中</option>
                                <option value="any">显示</option>
                                <option value="any">未显示</option>
                            </select>
                        </td>
                        <td>
                            <select name="jump_to_qid">
                                <option>请选择题目</option>
                                <option>Q3. 请给以下选项投票</option>
                            </select>
                        </td>
                        <td>
                            <i class="el-icon-remove" style="font-size: 24px;" @click="remove_show(index)"></i>
                        </td>
                    </tr>
                    <tr class="jumpconstraint">
                        <td>
                            <select name="option_id" class="option_select">
                                <option value="">请选择选项</option>
                                <option value="any">任意选项</option>
                            </select>
                        </td>
                        <td>
                            <select name="option_id" class="option_select">
                                <option value="">请选择条件</option>
                                <option value="any">选中</option>
                                <option value="any">未选中</option>
                                <option value="any">显示</option>
                                <option value="any">未显示</option>
                            </select>
                        </td>
                        <td>
                            <select name="jump_to_qid">
                                <option>请选择题目</option>
                                <option>Q3. 请给以下选项投票</option>
                            </select>
                        </td>
                        <td>
                            <i class="el-icon-circle-plus" style="font-size: 24px;" @click="add_show()"></i>
                        </td>
                    </tr>
                    </tbody>

                    <tbody v-if="!datas_show.length">
                    <tr class="jumpconstraint">
                        <td>
                            <select name="option_id" class="option_select">
                                <option value="">请选择选项</option>
                                <option value="any">任意选项</option>
                            </select>
                        </td>
                        <td>
                            <select name="option_id" class="option_select">
                                <option value="">请选择条件</option>
                                <option value="any">选中</option>
                                <option value="any">未选中</option>
                                <option value="any">显示</option>
                                <option value="any">未显示</option>
                            </select>
                        </td>
                        <td>
                            <select name="jump_to_qid">
                                <option>请选择题目</option>
                                <option>Q3. 请给以下选项投票</option>
                            </select>
                        </td>
                        <td>
                            <i class="el-icon-circle-plus" style="font-size: 24px;" @click="add_show()"></i>
                        </td>
                    </tr>
                    </tbody>
                </el-tab-pane>
            </el-tabs>
            <div slot="footer" class="dialog-footer">
                <el-button @click="settingDialog = false">取消</el-button>
                <el-button type="primary" @click="saveBatch()">确定</el-button>
            </div>
        </el-dialog> -->
		<!-- <div class="mask"  v-if="setLogic.phoneLogic == true"></div> -->
		<!-- <div class="details"  v-if="setLogic.phoneLogic == true"> -->
		<!-- <div> -->
		<!-- <el-tabs v-model="activeNa" @tab-click="handleClick"> -->
		<!-- <el-tab-pane label="跳转逻辑" name="first"> -->
		<!--  <div style="width:800px;border:1px solid red"> -->
		<!-- 跳转逻辑 -->
		<!-- </div> -->
		<!-- </el-tab-pane> -->
		<!-- <el-tab-pane label="显示逻辑" name="second"> -->
		<!-- <div style="width:800px;border:1px solid blue"> -->
		<!-- 显示逻辑 -->
		<!-- </div> -->
		<!-- </el-tab-pane> -->
		<!-- </el-tabs> -->
		<!-- </div> -->
		<!-- </div> -->
	</div>
</template>

<script>
import QuestionSingle2 from '@/components/QuestionSingle2';
import QuestionJudge from '@/components/QuestionJudge';
import QuestionMult2 from '@/components/QuestionMult2';
import QuestionBlank from '@/components/QuestionBlank';
import QuestionBlankMult from '@/components/QuestionBlankMult';
import QuestionRectMult from '@/components/QuestionRectMult';
import QuestionRectSingle from '@/components/QuestionRectSingle';
import QuestionAddress from '@/components/QuestionAddress';
import QuestionDate from '@/components/QuestionDate';
import QuestionDropDownBox from '@/components/QuestionDropDownBox';
import QuestionImage from '@/components/QuestionImage';
import QuestionSort from '@/components/QuestionSort';
import QuestionCity from '@/components/QuestionCity';
import QuestionTime from '@/components/QuestionTime';
import QuestionMu from '@/components/QuestionMu';
import QuestionMatrixBlank from '@/components/QuestionMatrixBlank';
import QuestionUploadFile from '@/components/QuestionUploadFile';
import QuestionParagraph from '@/components/QuestionParagraph';
import QuestionRate from '@/components/QuestionRate';
import QuestionMatrixRate from '@/components/QuestionMatrixRate';
import QuestionPaging from '@/components/QuestionPaging';
import QuestionCrosswiseBlank from '@/components/QuestionCrosswiseBlank';
import CheckType from '@/util/JSON/checkType.json';
export default {
	inject: ['reload'],
	name: 'wjEdit',
	components: {
		//ClassicEditor,
		QuestionJudge,
		QuestionSingle2,
		QuestionMult2,
		QuestionBlank,
		QuestionBlankMult,
		QuestionRectMult,
		QuestionRectSingle,
		QuestionAddress,
		QuestionDate,
		QuestionDropDownBox,
		QuestionImage,
		QuestionSort,
		QuestionCity,
		QuestionTime,
		QuestionMu,
		QuestionMatrixRate,
		QuestionUploadFile,
		QuestionParagraph,
		QuestionRate,
		QuestionMatrixBlank,
		QuestionPaging,
		QuestionCrosswiseBlank,
	},
	watch: {
		qtypeval(val) {
			if (val == '题目控件') {
				this.selectIndex = 0;
			} else if (val == '我的题库') {
				this.selectIndex = 1;
			}
		},
		selectIndex(val) {
			//this.qtypeval = "";
			if (val == 0) {
				this.qtypeval = '题目控件';
			} else if (val == 1) {
				this.qtypeval = '我的题库';
			}
		}
	},
	data() {
		return {
			ifFixedLastOption: '',
			inputLeast: '',
			content: [
				{
					ContentRes: ''
				},
				{
					lineInput: ''
				},
				{
					gapFil: ''
				},
				{
					multiline: ''
				}
			],
			setLogic: [
				{
					phoneLogic: false
				}
			],
			choice: [
				{
					leftChoice: ''
				},
				{
					rightChoice: ''
				},
				{
					sortsnums: ''
				}
			],
			choiceContent: [
				{
					label: '不限',
					value: '0'
				},
				{
					label: '1项',
					value: '1'
				},
				{
					label: '2项',
					value: '2'
				}
			],
			cityChoice: [
				{
					label: '详细到“详细地址”',
					value: '0'
				},
				{
					label: '详细到“区县”',
					value: '1'
				},
				{
					label: '详细到“城市”',
					value: '2'
				},
				{
					label: '详细到“省份”',
					value: '3'
				}
			],
			matrixLineRandom: '',
			radioChoice: '',
			questionLayout: 1,
			questionsType: 1,
			inGroupRandom: '',
			manualSetting: '',
			betweenGroupRandom: '',
			activeNa: 'first',
			values: false,
			startnum: 1,
			endnum: 500,
			answerNumber: '',
			answerlimit: '',
			startPassword: '',
			value1: null,
			display: 'none',
			left: 0,
			top: 0,
			questionsTypeId: '',
			switchID: '',
			curWjInfo: {},
			questionlist: [],
			selectIndex: 0,
			selectTypeIndex: 0,
			isCollapse: true,
			activeNames: [0, 1, 2, 3],
			asklist: [],
			activeName: 'first',
			titleNumber: 0,
			tx_setting_id: '',
			tx_setting: [
				{
					id: '1',
					label: '题型',
					icon: require('../assets/tx/tab_def_icon1.png'),
					icon2: require('../assets/tx/tab_sel_icon1.png')
				},
				{
					id: '2',
					label: '题库',
					icon: require('../assets/tx/tab_def_icon2.png'),
					icon2: require('../assets/tx/tab_sel_icon2.png')
				},
				{
					id: '3',
					label: '逻辑',
					icon: require('../assets/tx/tab_def_icon3.png'),
					icon2: require('../assets/tx/tab_sel_icon3.png')
				},
				{
					id: '4',
					label: '外观',
					icon: require('../assets/tx/tab_def_icon4.png'),
					icon2: require('../assets/tx/tab_sel_icon4.png')
				},
				{
					id: '5',
					label: '设置',
					icon: require('../assets/tx/tab_def_icon5.png'),
					icon2: require('../assets/tx/tab_sel_icon5.png')
				}
			],
			qtypes: ['题目控件', '我的题库'],
			qtypeval: '题目控件',
			height: 0,
			rightheight: 0,
			activeIndex: '0',
			editIndex: -1,
			ifMustAnswer: '',
			optionIfRandom: '',
			// optionIfRandom: false,
			// ifMustSingle: "单选",
			// choiceLayout: "单列",
			datas_logic: [],
			datas_show: [],
			editOptionIndex: '0_0',
			wjTypeList: [],
			typeIndex: -1,
			centerDialogVisible: false,
			tkList: [],
			curTkType: {},
			curSzType: {},
			searchQuestionsName: '',
			showSzDialog: false,
			settingDialog: false,
			szTypeList: [
				{
					id: 1,
					title: '答题设置',
					icon: '',
					icon1: '',
					list: [
						{
							id: 1,
							title: '每个微信答题次数限制',
							icon: '',
							icon1: '',
							switch: false
						},
						{
							id: 2,
							title: '每台电脑或手机答题次数限制',
							icon: '',
							icon1: '',
							switch: false
						},
						{
							id: 3,
							title: '每个IP答题次数限制 ',
							icon: '',
							icon1: '',
							switch: false
						},
						{
							id: 4,
							title: '启动访问密码',
							icon: '',
							icon1: '',
							switch: false
						},
						{
							id: 5,
							title: '只有邮件邀请的受访者可回答',
							icon: '',
							icon1: '',
							switch: false
						},
						{
							id: 6,
							title: '设置开始/结束时间',
							icon: '',
							icon1: '',
							switch: false
						},
						{
							id: 7,
							title: '只能通过微信回答',
							icon: '',
							icon1: '',
							switch: false
						},
						{
							id: 8,
							title: '记录微信用户个人信息',
							icon: '',
							icon1: '',
							switch: false
						}
					]
				},
				{
					id: 2,
					title: '微信设置',
					icon: '',
					icon1: '',
					list: [
						{
							id: 1,
							title: '每个微信答题次数限制',
							icon: '',
							icon1: ''
						},
						{
							id: 1,
							title: '只能通过微信回答',
							icon: '',
							icon1: ''
						},
						{
							id: 1,
							title: '记录微信用户个人信息',
							icon: '',
							icon1: ''
						},
						{
							id: 1,
							title: '必须关注我的官方微信才能回答 （该功能需要先 绑定微信服务号 ）',
							icon: '',
							icon1: ''
						},
						{
							id: 1,
							title: '自定义微信分享图标',
							icon: '',
							icon1: ''
						},
						{
							id: 1,
							title: '禁止微信右上角分享',
							icon: '',
							icon1: ''
						}
					]
				},
				{
					id: 3,
					title: '提醒设置',
					icon: '',
					icon1: '',
					list: [
						{
							id: 1,
							title: '有新数据时，通过微信提醒我',
							icon: '',
							icon1: ''
						}
					]
				},
				{
					id: 4,
					title: '质量设置',
					icon: '',
					icon1: '',
					list: [
						{
							id: 1,
							title: '设定答题数据上限',
							icon: '',
							icon1: ''
						},
						{
							id: 1,
							title: '配额',
							icon: '',
							icon1: ''
						},
						{
							id: 1,
							title: '无效答卷筛选',
							icon: '',
							icon1: ''
						}
					]
				},
				{
					id: 5,
					title: '查询设置',
					icon: '',
					icon1: '',
					list: [
						{
							id: 1,
							title: '对外查询设置',
							icon: '',
							icon1: ''
						}
					]
				},
				{
					id: 6,
					title: '奖品与红包',
					icon: '',
					icon1: '',
					list: [
						{
							id: 1,
							title: '微信红包',
							icon: '',
							icon1: ''
						}
					]
				},
				{
					id: 7,
					title: '其他设置',
					icon: '',
					icon1: '',
					list: [
						{
							id: 1,
							title: '保存上次填写内容',
							icon: '',
							icon1: ''
						},
						{
							id: 1,
							title: '允许搜索引擎检索项目内容',
							icon: '',
							icon1: ''
						}
					]
				}
			],
			resultBody: {},
			wjId: '',
			wxLimitFreqOptions: [
				{ value: '0', label: '只能' },
				{ value: '1', label: '每小时' },
				{ value: '2', label: '每天' },
				{ value: '3', label: '没周' },
				{ value: '4', label: '每月' }
			],
			wxLimitFreq: '', // 每个微信答题状态
			wxLimitNumber: '', // 每个微信答题次数限制
			pcLimitNumber: '', // 每台电脑或手机答题次数限制
			ipLimitNumber: '', // 每个IP答题次数限制
			startPasswordNumber: '', //启动访问密码
			pcLimitFreq: '', // 每台电脑或手机答题状态
			ipLimitFreq: '', // 每个IP答题次数状态
			startTimerState: false, // 设置开始时间状态
			currentSort: 0,
			matrixRankRandom: '',
			lineRankExchange: '',
			questionlineRank: 0,
			inputMoster: '',
			qindex: 0,
			showIndex: 0
		};
	},
  	computed: {
		//选项验证类型
		ContentRestrictions () {
			return CheckType
		}
	},
	watch: {
		startnum(oldval, newval) {
			console.log('oldval', oldval, '=====', 'newval', newval);
			if (this.startnum <= 0) {
				this.startnum = 0;
			}
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setupleast}`,
				method: 'POST',
				data: {
					id: that.switchID,
					least: oldval
				},
				cb(res) {
					if (res.code == 0) {
						console.log('输出', res);
					}
				}
			};
			this.$util.request(params);
		},
		endnum(oldval, newval) {
			console.log('oldval', oldval, '====', 'newval', newval);
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setupmost}`,
				method: 'POST',
				data: {
					id: that.switchID,
					most: oldval
				},
				cb(res) {
					if (res.code == 0) {
						console.log('输出', res);
					}
				}
			};
			this.$util.request(params);
		}
	},
	mounted: function() {
		let that = this;
		this.loadAskTypeData();
		var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
		this.height = winHeight - 108;
		this.rightheight = winHeight - 60;
		window.onresize = () => {
			var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
			this.height = winHeight - 108;
			this.rightheight = winHeight - 60;
		};

		//在mounted钩子函数绑定滚动条事件
		document.getElementById('wenjuan_list').addEventListener('scroll', this.scroll);
		that.wid = sessionStorage.getItem('wid') || 0;
		if (that.wid == 0) {
			this.wjadd();
		} else {
			sessionStorage.setItem('wid', that.wid);
			this.wjinfo();
		}
		this.loadWjTypes();
	},
	methods: {
		fixation(id) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.fixedlastoption}`,
				method: 'POST',
				data: {
					id: id
				},
				cb(res) {
					if (res.code == 0) {
						console.log('输出', res);
					}
				}
			};
			this.$util.request(params);
		},
		inpMoster(value, id) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setupmost}`,
				method: 'POST',
				data: {
					id: id,
					least: value
				},
				cb(res) {
					if (res.code == 0) {
						console.log('输出', res);
					}
				}
			};
			this.$util.request(params);
		},
		inpLeast(value, id) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setupleast}`,
				method: 'POST',
				data: {
					id: id,
					least: value
				},
				cb(res) {
					if (res.code == 0) {
						console.log('输出', res);
					}
				}
			};
			this.$util.request(params);
		},
		switchoverType(num, id) {
			this.questionlineRank = num;
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.questionInputBox}`,
				method: 'POST',
				data: {
					id: id,
					inputBoxSetting: num
				},
				cb(res) {
					if (res.code == 0) {
						that.reload();
						console.log('输出', res);
					}
				}
			};
			this.$util.request(params);
		},
		lineRank(id) {
			// let that = this;
			// let params = {
			//     that: this,
			//     url: `${this.$config.service.MatrixRankRandom}`,
			//     method: "POST",
			//     data:{
			//         id:id
			//     },
			//     cb(res) {
			//         if (res.code == 0) {
			//             console.log('输出',res)
			//         }
			//     }
			// };
			// this.$util.request(params);
		},
		RankMartix(id) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.MatrixRankRandom}`,
				method: 'POST',
				data: {
					id: id
				},
				cb(res) {
					if (res.code == 0) {
						console.log('输出', res);
					}
				}
			};
			this.$util.request(params);
		},
		lineMartix(id) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.MatrixLineRandom}`,
				method: 'POST',
				data: {
					id: id
				},
				cb(res) {
					if (res.code == 0) {
						console.log('输出', res);
					}
				}
			};
			this.$util.request(params);
		},
		setDetails(id, val) {
			console.log('城市选择输出', id, val);
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setupCitySelection}`,
				method: 'POST',
				data: {
					choiceRange: val.value,
					questionsId: id
				},
				cb(res) {
					if (res.code == 0) {
						console.log('输出', res);
						that.loadQuestionList();
					}
				}
			};
			this.$util.request(params);
		},
		manSet(id) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.BoxAppearance}`,
				method: 'POST',
				data: {
					id: id
				},
				cb(res) {
					if (res.code == 0) {
						console.log('输出', res);
					}
				}
			};
			this.$util.request(params);
		},
		choiceNum(val, id) {
			console.log('11111', val, id);
		},
		setLayout(index, id) {
			this.questionLayout = index;
			console.log(index, id);
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.choiceLayout}`,
				method: 'POST',
				data: {
					id: id,
					choiceLayout: index
				},
				cb(res) {
					if (res.code == 0) {
						console.log('输出', res);
						that.reload();
					}
				}
			};
			this.$util.request(params);
		},
		setTopic(index, id) {
			this.questionsType = index;
			if (index == 1) {
				let that = this;
				let params = {
					that: this,
					url: `${this.$config.service.setupsingleoption}`,
					method: 'POST',
					data: {
						id: id
					},
					cb(res) {
						if (res.code == 0) {
							that.reload();
							console.log('输出', res);
						}
					}
				};
				this.$util.request(params);
			} else if (index == 2) {
				let that = this;
				let params = {
					that: this,
					url: `${this.$config.service.setupmanyoption}`,
					method: 'POST',
					data: {
						id: id
					},
					cb(res) {
						if (res.code == 0) {
							that.reload();
							console.log('输出', res);
						}
					}
				};
				this.$util.request(params);
			}
		},
		// 组间排序
		betRan(id) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setBetweenGroupRandom}`,
				method: 'POST',
				data: {
					id: id
				},
				cb(res) {
					if (res.code == 0) {
						console.log('输出', res);
					}
				}
			};
			this.$util.request(params);
		},
		// 组内排序
		inGroupR(id) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setInGroupRandom}`,
				method: 'POST',
				data: {
					id: id
				},
				cb(res) {
					if (res.code == 0) {
						console.log('输出', res);
					}
				}
			};
			this.$util.request(params);
		},
		handleClick(tab, event) {
			console.log(tab, event);
		},
		setInputSize(index, id) {
			this.currentSort = index;
			console.log('点击时输出', index);
			console.log('1', id);
			let inputSize = 0;
			if (index == 0 || index == 3) {
				inputSize = 30;
			} else if (index == 1 || index == 4) {
				inputSize = 60;
			} else if (index == 2 || index == 5) {
				inputSize = 90;
			}
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setInputBoxSize}`,
				method: 'POST',
				data: {
					id: id,
					inputBoxSize: inputSize
				},
				cb(res) {
					if (res.code == 0) {
						console.log('输出', res);

						that.loadQuestionList();
					}
				}
			};
			this.$util.request(params);
		},
		RandomArr(id) {
			console.log(id);
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setupoptionifrandom}`,
				method: 'POST',
				data: {
					id: id
				},
				cb(res) {
					if (res.code == 0) {
						console.log('输出', res);
					}
				}
			};
			this.$util.request(params);
		},
		contents(val, id) {
			console.log('改变输出', val);
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setIfLengthLimit}`,
				method: 'POST',
				data: {
					id: id,
					ifLengthLimit: val
				},
				cb(res) {
					if (res.code == 0) {
						console.log('输出', res);
					}
				}
			};
			this.$util.request(params);
		},
		mustAnswer(id) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setupifmustanswer}`,
				method: 'POST',
				data: {
					id: id
				},
				cb(res) {
					if (res.code == 0) {
						console.log('设置成功后输出', that.ifMustAnswer);
						that.loadQuestionList();
					}
				}
			};
			this.$util.request(params);
		},
		startTimer() {
			if (event.target.checked == true) {
				this.startTimerState = true;
			} else if (event.target.checked == false) {
				this.startTimerState = false;
			}
		},
		answerNumbers(num) {
			// console.log(num);
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.answerTime}`,
				method: 'POST',
				data: {
					id: that.wjId,
					pageAnswerTime: num
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		answerLimit(limit) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.answerlimit}`,
				method: 'POST',
				data: {
					id: that.wjId,
					setAnswerLimitNumber: limit
				},
				cb(res) {
					if (res.code == 0) {
						console.log('管边', res);
					}
				}
			};
			this.$util.request(params);
		},
		startPsSure(val) {
			console.log(val);
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.startuppassword}`,
				method: 'POST',
				data: {
					id: that.wjId,
					password: val
				},
				cb(res) {
					if (res.code == 0) {
						console.log('管边', res);
					}
				}
			};
			this.$util.request(params);
		},
		wxIplimitInput() {
			let wxlimitInputFreq = this.ipLimitFreq;
			if (wxlimitInputFreq == '只能') {
				wxlimitInputFreq = '0';
			} else if (wxlimitInputFreq == '每小时') {
				wxlimitInputFreq = '1';
			} else if (wxlimitInputFreq == '每天') {
				wxlimitInputFreq = '2';
			} else if (wxlimitInputFreq == '每周') {
				wxlimitInputFreq = '3';
			} else if (wxlimitInputFreq == '每月') {
				wxlimitInputFreq = '4';
			}
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.updaipLimitNumber}`,
				method: 'POST',
				data: {
					id: that.wjId,
					ipLimitFreq: wxlimitInputFreq,
					ipLimitNumber: that.ipLimitNumber
				},
				cb(res) {
					if (res.code == 0) {
						console.log('管边', res);
					}
				}
			};
			this.$util.request(params);
		},
		wxIpLimit(e) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.updaipLimitNumber}`,
				method: 'POST',
				data: {
					id: that.wjId,
					ipLimitFreq: e,
					ipLimitNumber: that.ipLimitNumber
				},
				cb(res) {
					if (res.code == 0) {
						console.log('管边', res);
					}
				}
			};
			this.$util.request(params);
		},
		wxPclimitInput() {
			let wxlimitInputFreq = this.pcLimitFreq;
			if (wxlimitInputFreq == '只能') {
				wxlimitInputFreq = '0';
			} else if (wxlimitInputFreq == '每小时') {
				wxlimitInputFreq = '1';
			} else if (wxlimitInputFreq == '每天') {
				wxlimitInputFreq = '2';
			} else if (wxlimitInputFreq == '每周') {
				wxlimitInputFreq = '3';
			} else if (wxlimitInputFreq == '每月') {
				wxlimitInputFreq = '4';
			}
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.pclimitnumber}`,
				method: 'POST',
				data: {
					id: that.wjId,
					pcLimitFreq: wxlimitInputFreq,
					pcLimitNumber: that.pcLimitNumber
				},
				cb(res) {
					if (res.code == 0) {
						console.log('管边', res);
					}
				}
			};
			this.$util.request(params);
		},
		wxPcLimit(e) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.pclimitnumber}`,
				method: 'POST',
				data: {
					id: that.wjId,
					pcLimitFreq: e,
					pcLimitNumber: that.pcLimitNumber
				},
				cb(res) {
					if (res.code == 0) {
						console.log('管边', res);
					}
				}
			};
			this.$util.request(params);
		},
		wxlimitInput() {
			let wxlimitInputFreq = this.wxLimitFreq;
			if (wxlimitInputFreq == '只能') {
				wxlimitInputFreq = '0';
			} else if (wxlimitInputFreq == '每小时') {
				wxlimitInputFreq = '1';
			} else if (wxlimitInputFreq == '每天') {
				wxlimitInputFreq = '2';
			} else if (wxlimitInputFreq == '每周') {
				wxlimitInputFreq = '3';
			} else if (wxlimitInputFreq == '每月') {
				wxlimitInputFreq = '4';
			}
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.updawxlimitnumber}`,
				method: 'POST',
				data: {
					id: that.wjId,
					wxLimitFreq: wxlimitInputFreq,
					wxLimitNumber: that.wxLimitNumber
				},
				cb(res) {
					if (res.code == 0) {
						console.log('管边', res);
					}
				}
			};
			this.$util.request(params);
		},
		wxLimit(e) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.updawxlimitnumber}`,
				method: 'POST',
				data: {
					id: that.wjId,
					wxLimitFreq: e,
					wxLimitNumber: that.wxLimitNumber
				},
				cb(res) {
					if (res.code == 0) {
						console.log('管边', res);
					}
				}
			};
			this.$util.request(params);
		},
		switchHideLogo(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setHideLogo}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchShareSeoIndex(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setShareSeoIndex}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchCustomJump(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setIfCustomJump}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchIfDisplayShare(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setIfDisplayShare}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchIfAllowStatistics(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setIfPageAnswerTime}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchPageAnswerTime(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setIfPageAnswerTime}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchIfAnswerDataLimit(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setupSetAnswerLimit}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchProhibitWXShare(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setProhibitWXShare}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchRecordWxUser(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setuprecordwxuser}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchOnlyWx(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setuponlywx}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchNewMsgtoEmail(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setNewMsgtoEmail}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchNewMsgtoWX(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setNewMsgtoWX}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchBreakpointAnswer(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setBreakpointAnswer}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchSetStartEndTime(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setupsetstartendtime}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchOnlyEmail(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setuponlyemail}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchStartUpPassword(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setupstartuppassword}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchpLimit(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setupiplimit}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchPcLimit(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setupclimit}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		switchWxLimit(value) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setupwxlimit}`,
				method: 'POST',
				data: {
					id: that.wjId
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
					}
				}
			};
			this.$util.request(params);
		},
		// setting_ismust() {
		//     let optionIfRandom = this.optionIfRandom;
		//     let that = this;
		//     let params = {
		//         that: this,
		//         url: `${this.$config.service.setupifmustanswer}?id=${that.editCurQuestion.id}`,
		//         method: "POST",
		//         cb(res) {
		//             if (res.code == 0) {
		//                 let message = res.message;
		//                 that.$message.success(message);
		//             }
		//         }
		//     };
		//     this.$util.request(params);
		// },
		// setting_israndom() {
		//     let optionIfRandom = this.optionIfRandom;
		//     let that = this;
		//     let params = {
		//         that: this,
		//         url: `${this.$config.service.setupoptionifrandom}?id=${that.editCurQuestion.id}`,
		//         method: "POST",
		//         cb(res) {
		//             if (res.code == 0) {
		//                 let message = res.message;
		//                 that.$message.success(message);
		//             }
		//         }
		//     };
		//     this.$util.request(params);
		// },
		logicSetting() {
			this.settingDialog = true;
		},
		scroll() {
			let that = this;
			that.display = 'none';
		},
		loadAskTypeData() {
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.questionTypeList,
				data: {},
				cb(res) {
					if (res.code == 0) {
						that.asklist = res.resultBody.questionTypeOneList;
						that.asklist = that.asklist.map((info) => {
							info.questionTypeList = info.questionTypeList.map(val => {
								val.type = val.type.toString()
								return val
							})
							return info
						})
					}
				}
			};
			this.$util.request(params);
		},
		wjinfo() {
			let that = this;
			let id = that.wid;
			let params = {
				that: this,
				url: `${this.$config.service.wjinfo}?id=${id}`,
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.curWjInfo = res.resultBody;
						that.loadQuestionList();
					}
				}
			};
			this.$util.request(params);
		},
		wjadd() {
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.wjadd,
				data: {
					content: '',
					wjTitle: '问卷标题',
					wjType: '问卷类型'
				},
				cb(res) {
					if (res.code == 0) {
						that.curWjInfo = res.resultBody;
						sessionStorage.setItem('wid', that.curWjInfo.id);
						that.loadQuestionList();
					}
				}
			};
			this.$util.request(params);
		},
		loadQuestionList() {
					console.log("=======", callback);
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.questionlist}?id=${that.curWjInfo.id}`,
				method: 'GET',
				data: {},
				cb(res) {
					if (res.code == 0) {
						that.questionlist = res.resultBody.questionsList;
						console.log(that.questionlist);
						that.resultBody = res.resultBody;
						that.wjId = res.resultBody.id;
						that.wxLimitFreq = res.resultBody.wxLimitFreq; // 每个微信答题次数状态
						that.wxLimitNumber = res.resultBody.wxLimitNumber; // 每个微信答题次数限制
						that.pcLimitNumber = res.resultBody.pcLimitNumber; // 每台电脑或手机答题次数限制
						that.ipLimitNumber = res.resultBody.ipLimitNumber; // 每个IP答题次数限制
						that.startPasswordNumber = res.resultBody.startUpPasswordNumber; //启动访问密码
						that.pcLimitFreq = res.resultBody.pcLimitFreq; // 每台电脑或手机答题状态
						that.ipLimitFreq = res.resultBody.ipLimitFreq; // 每个IP答题次数状态
						if (that.wxLimitFreq == 0) {
							that.wxLimitFreq = '只能';
						} else if (that.wxLimitFreq == 1) {
							that.wxLimitFreq = '每小时';
						} else if (that.wxLimitFreq == 2) {
							that.wxLimitFreq = '每天';
						} else if (that.wxLimitFreq == 3) {
							that.wxLimitFreq = '每周';
						} else if (that.wxLimitFreq == 4) {
							that.wxLimitFreq = '每月';
						}
						if (that.pcLimitFreq == 0) {
							that.pcLimitFreq = '只能';
						} else if (that.pcLimitFreq == 1) {
							that.pcLimitFreq = '每小时';
						} else if (that.pcLimitFreq == 2) {
							that.pcLimitFreq = '每天';
						} else if (that.pcLimitFreq == 3) {
							that.pcLimitFreq = '每周';
						} else if (that.pcLimitFreq == 4) {
							that.pcLimitFreq = '每月';
						}
						if (that.ipLimitFreq == 0) {
							that.ipLimitFreq = '只能';
						} else if (that.ipLimitFreq == 1) {
							that.ipLimitFreq = '每小时';
						} else if (that.ipLimitFreq == 2) {
							that.ipLimitFreq = '每天';
						} else if (that.ipLimitFreq == 3) {
							that.ipLimitFreq = '每周';
						} else if (that.ipLimitFreq == 4) {
							that.ipLimitFreq = '每月';
						}
					}
				}
			};
			this.$util.request(params);
		},
		selectTypeQuestion(index, item) {
			this.selectTypeIndex = index;
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.questionadd,
				data: {
					questionnaireId: that.curWjInfo.id,
					questionsTypeId: item.id,
					editIndex: that.editIndex
				},
				cb(res) {
					if (res.code == 0) {
						that.$message.success(res.message);

						if (that.editIndex > 0) {
							that.questionlist.splice(that.editIndex + 1, 0, res.resultBody);
							that.editIndex = that.editIndex + 1;
						} else {
							that.questionlist.push(res.resultBody);
							that.editIndex = that.questionlist.length - 1;
						}
						that.editCurQuestion = that.questionlist[that.editIndex];
						if (res.resultBody.questionsTypeId == 26) {
							if (that.questionlist[0].questionTypeId != 26) {
								console.log(res.resultBody.questionsSonList[0]);
								that.questionlist.unshift(res.resultBody.questionsSonList[0]);
							}
						}
						if (that.editIndex < 0) {
							setTimeout(() => {
								let div = document.getElementById('wenjuan_list');
								div.scrollTop = div.scrollHeight;
							}, 400);
						}
						that.calcequestionindex();
						return;
					}
					that.$message.error(res.message);
				}
			};
			this.$util.request(params);
		},
		calcequestionindex() {
			var qindex = 1;
			for (var i = 0; i < this.questionlist.length; i++) {
				if (this.questionlist[i].questionTypeId != 26) {
					this.questionlist[i].qindex = qindex;
					qindex++;
				}
			}
		},
		addQuestionItem(item) {
			console.log(item, '111');
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.questionadd,
				data: {
					questionnaireId: that.curWjInfo.id,
					questionsId: item.id
				},
				cb(res) {
					if (res.code == 0) {
						this.reload();
						that.$message.success(res.message);
						item.questionsSonList.push(res.resultBody);
						return;
					}
					that.$message.error(res.message);
				}
			};
			this.$util.request(params);
		},
		selectIcon(index) {
			this.selectIndex = index;
			console.log('输出', index);
			// if(index == 0){
			//     this.$router.push('/questionType')
			// }else if(index == 1){
			//     this.$router.push('/questionBank')
			// }else if(index == 2){
			//     this.$router.push('/logic')
			// }else if(index == 3){
			//     this.$router.push('/logic')
			// }else if(index == 4){
			//     this.$router.push('/appearance')
			// }
		},
		wjaddquestionoption(options, item, type = 0) {
			if (type == 2) {
				this.editCurQuestion = item;
				this.batchDialog = true;
				this.batchlist = '';
				return;
			}
			let url = `${this.$config.service.addoneoption}?id=${item.id}`;
			if (type == 1) {
				url = `${this.$config.service.addoneotheroption}?id=${item.id}`;
			}
			let that = this;
			let params = {
				that: this,
				url: url,
				data: {},
				cb(res) {
					if (res.code == 0) {
						options.push(res.resultBody);
						that.$message.success(res.message);
						return;
					}
					that.$message.error(res.message);
				}
			};
			this.$util.request(params);
		},
		addMatrixQuestionsOption(options, item) {
			let url = `${this.$config.service.addMatrixQuestionsOption}`;
			let that = this;
			let params = {
				that: this,
				url: url,
				data: {
					questionsId: item.id
				},
				cb(res) {
					if (res.code == 0) {
						options.push(res.resultBody.datas[0]);
						that.$message.success(res.message);
						return;
					}
					that.$message.error(res.message);
				}
			};
			this.$util.request(params);
		},
		wjdelquestionoption(options, item, childindex) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.deloneoption}?id=${item.id}`,
				data: {},
				cb(res) {
					if (res.code == 0) {
						options.splice(childindex, 1);
						return;
					}
					that.$message.error(res.message);
				}
			};
			this.$util.request(params);
		},
		questiondel(id) {
			let that = this;
			this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'info'
			})
				.then(() => {
					let params = {
						that: that,
						url: `${that.$config.service.questiondel}?id=${id}`,
						data: {},
						cb(res) {
							if (res.code == 0) {
								that.questionlist = [];
								that.loadQuestionList();
								that.$message.success(res.message);
								return;
							}
							that.$message.error(res.message);
						}
					};
					that.$util.request(params);
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		},
		showAdvance() {},
		setEditIndex(index) {
			let that = this;
			let curselected = document.getElementById(this.editIndex);
			if (curselected) {
				curselected.classList.remove('item_container_hover');
			}
			document.getElementById(index).classList.add('item_container_hover');
			this.editIndex = index;
			that.editCurQuestion = that.questionlist[that.editIndex];
			that.ifMustAnswer = that.editCurQuestion.ifMustAnswer == 1 ? true : false;
			that.optionIfRandom = that.editCurQuestion.optionIfRandom == 1 ? true : false;
			that.questionsTypeId = that.questionlist[index].questionsTypeId;
			that.switchID = that.questionlist[index].id;
			that.ifMustAnswer = that.questionlist[index].ifMustAnswer;
			that.optionIfRandom = that.questionlist[index].optionIfRandom;
			that.betweenGroupRandom = that.questionlist[index].betweenGroupRandom;
			that.inGroupRandom = that.questionlist[index].inGroupRandom;
			that.manualSetting = that.questionlist[index].manualSetting;
			that.matrixLineRandom = that.questionlist[index].matrixLineRandom;
			that.matrixRankRandom = that.questionlist[index].matrixRankRandom;
			that.lineRankExchange = that.questionlist[index].lineRankExchange;
			that.ifFixedLastOption = that.questionlist[index].ifFixedLastOption;
			that.questionsType = that.questionlist[index].ifMustSingle;
			that.questionLayout = that.questionlist[index].choiceLayout;
			that.questionlineRank = that.questionlist[index].inputBoxSetting;
			console.log('选中输出', that.ifMustAnswer);
			console.log(that.questionlist[index].questionsTypeId);
		},
		setEditOptionIndex(childIndex) {
			this.editOptionIndex = this.editIndex + '_' + childIndex;
		},
		wjupdquestionoption(item) {
			let url = `${this.$config.service.questionupd}`;
			let that = this;
			let params = {
				that: this,
				url: url,
				data: {
					id: item.id,
					questionsName: item.questionsName
				},
				cb(res) {
					if (res.code == 0) {
						that.$message.success(res.message);
						return;
					}
					that.$message.error(res.message);
				}
			};
			this.$util.request(params);
		},
		wjupdoption(item) {
			let url = `${this.$config.service.questionupdoption}`;
			let that = this;
			let params = {
				that: this,
				url: url,
				data: {
					id: item.id,
					labelName: item.labelName
				},
				cb(res) {
					if (res.code == 0) {
						that.$message.success(res.message);
						return;
					}
					that.$message.error(res.message);
				}
			};
			this.$util.request(params);
		},
		wjedit() {
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.wjedit,
				data: {
					content: that.curWjInfo.content,
					wjTitle: that.curWjInfo.wjTitle,
					id: that.curWjInfo.id
				},
				cb(res) {
					if (res.code == 0) {
						that.$message.success(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		loadWjTypes() {
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.queryQuestionTypes,
				data: {},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.wjTypeList = res.resultBody.datas;
						return;
					}
					that.$message.error(res.message);
				}
			};
			this.$util.request(params);
		},
		showQuestionList(index, item) {
			this.centerDialogVisible = true;
			this.typeIndex = index;
			this.curTkType = item;
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.queryTestQuestions,
				data: {
					questionTypeId: item.id,
					questionsName: that.searchQuestionsName
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.tkList = res.resultBody.datas;
						return;
					} else {
						that.tkList = [];
					}
				}
			};
			this.$util.request(params);
		},
		addTkItem(item) {
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.addNewQuestions,
				data: {
					questionnaireId: this.curWjInfo.id,
					questions: [item.id]
				},
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.centerDialogVisible = false;
						that.loadQuestionList();
						setTimeout(() => {
							let div = document.getElementById('wenjuan_list');
							div.scrollTop = div.scrollHeight;
						}, 400);
						return;
					}
					that.$message.error(res.message);
				}
			};
			this.$util.request(params);
		},
		selectSzItem(item) {
			this.showSzDialog = true;
			this.curSzType = item;
		},
		add_logic() {
			this.datas_logic.push({});
		},
		remove_logic(index) {
			this.datas_logic.splice(index, 1);
		},
		add_show() {
			this.datas_show.push({});
		},
		remove_show(index) {
			this.datas_show.splice(index, 1);
			//this.datas_logic = JSON.parse(JSON.stringify(this.datas_logic))
		}
	}
};
</script>

<style scoped>
div.wj-title {
	line-height: 44px;
	margin-top: 20px;
	padding: 0 15px;
	background-color: #f1f1f1;
	border-radius: 3px;
	font-size: 18px;
	font-family: Arial;
	color: #606266;
}
/deep/.el-tabs__nav {
	width: 850px !important;
	height: 56px !important;
	line-height: 60px !important;
	margin-left: 25px;
}
.mask {
	position: fixed;
	left: 0;
	top: 0;
	z-index: 2;
	width: 100%;
	height: 100%;
	background: #000;
	opacity: 0.3;
}
.details {
	/* 遮罩层内容 */
	position: fixed;
	background: #fff;
	width: 850px;
	height: auto;
	overflow: auto;
	opacity: 1;
	z-index: 5;
	top: 30%;
	left: 29%;
}
.numLimit {
	margin: 0 5px;
}
.heade {
	padding: 0px 4px;
	border: 1px solid #ccc;
}
/deep/.right .el-input__inner {
	width: 94px !important;
	height: 24px !important;
	border: 1px solid #ccc !important;
}
.activeCheck {
	border: 1px solid #0080ff !important;
	color: #0080ff;
}
.tab_layout span {
	padding: 1px 7px;
	border: 1px solid #ccc;
}
/deep/.tab_layout .el-button {
	width: 30px !important;
	height: 24px !important;
	text-align: center !important;
	line-height: 24px !important;
	margin-left: 0px;
	padding: 0;
	border-radius: 0px;
}
.w-btn-wrapper {
	position: relative;
	color: #707070;
	background: #fff;
	height: 24px;
	padding: 0 10px;
	font-size: 12px;
	line-height: 49px;
	border: 1px solid #d8d8d8;
}
.w-btn-wrapper.checked {
	z-index: 1;
	color: #0080ff;
	border-color: #0080ff;
}
.heiSetting {
	height: 49px;
	line-height: 49px;
	border-bottom: 1px solid #ccc;
	font-size: 14px;
}
.setTimer_num div {
	width: 629px;
	height: 40px;
	line-height: 40px;
}
.setTimer_num {
	width: 629px;
	height: 120px;
	display: flex;
	flex-direction: column;
	margin-left: 20px;
}
.answerlimit {
	width: 60px;
	height: 24px;
	border: 1px solid #ccc !important;
	margin-left: 8px;
	margin-right: 8px;
}
.wx_limit_number span {
	font-size: 13px;
	width: 50px;
}
.wx_limit_number {
	display: flex;
	margin-left: 20px;
	height: 52px;
	align-items: center;
}
/deep/.wx_limit_number .el-input__inner {
	width: 60px;
	height: 24px;
	border: 1px solid #ccc !important;
}
/deep/.wx_limt .el-select .el-input__inner {
	width: 100px;
	height: 24px;
	line-height: 24px;
	border: 1px solid #ccc !important;
}
/deep/.wx_limt .el-select__caret {
	height: 24px;
	line-height: 24px;
}
.button_line span i {
	width: 16px;
	height: 16px;
}
.limit_num {
	width: 629px;
	height: 52px;
	display: flex;
	margin-left: 20px;
	align-items: center;
}
.limit_num_box {
	width: 700px;
	border-top: 1px solid #e1e1e1;
	border-bottom: 1px solid #e1e1e1;
	background: #f7f8fa;
}
.button_line {
	width: 629px;
	margin-left: 20px;
	height: 60px;
	display: flex;
	align-items: center;
	border-bottom: 1px solid #e1e1e1;
	justify-content: space-between;
}
.limit a {
	width: 4px;
	height: 22px;
	background: #0080ff;
	border-radius: 2px;
}
.limit {
	font-family: MicrosoftYaHei;
	font-size: 18px;
	color: #333;
	margin-top: 25px;
	border-left: 4px solid #0080ff;
	border-radius: 2px;
	padding-left: 5px;
}
.answer_set {
	width: 700px;
	height: auto;
	margin: 0 auto;
}
el-rate {
	width: 1160px;
	height: 250px;
}
.wjType {
	width: 360px;
	float: left;
	display: inline;
}
.wjEdit {
	float: left;
	display: inline;
}
.wjTypeChild {
	width: 80px;
	background-color: #fff;
	padding-top: 15px;
	padding-bottom: 30px;
	float: left;
	display: inline;
}
.display_inline {
	display: inline;
	float: left;
	height: 68px;
	line-height: 68px;
}
.wjTypeChildQuestion {
	margin-left: 2px;
	width: 278px;
	background-color: #fff;
	padding-top: 15px;
	padding-bottom: 30px;
	float: left;
	display: inline;
	overflow-y: auto;
}
.tk_item {
	width: 260px;
	height: 69px;
	margin: 0px auto;
	border-bottom: 1px #d5d5d6 solid;
}
.wjTypeChildItemFont {
	font-size: 14px;
	cursor: pointer;
}
.wjTypeChildItem {
	text-align: center;
	margin-top: 40px;
}
.icon {
	margin: 0px auto;
	width: 50px;
	height: 50px;
	border-radius: 5px;
}
.center {
	text-align: center;
}
.iconActive {
	color: #0080ff;
}
.iconActive > .icon {
	background-color: #0080ff;
}
.qtypeTitle {
	padding-left: 15px;
	height: 40px;
	line-height: 40px;
	font-weight: bold;
	font-size: 16px;
}
.qtypeItem {
	text-align: center;
	display: inline;
	float: left;
	width: 80px;
	height: 80px;
	border: 1px solid #eaeaea;
}
.dt-title {
	text-align: center;
	margin-top: 20px;
	font-size: 16px;
}
.tx_box {
	width: 100%;
	min-height: 300px;
	margin-top: 30px;
	padding-bottom: 20px;
	background: #fff;
	box-shadow: 1px 3px 17px -5px #aeaeae;
}
.tj_box li {
	flex: 1;
	height: 100%;
	border-right: 1px solid #ccc;
}
.tj_box li p {
	font-size: 16px;
	color: #333;
	margin-bottom: 20px;
}
.tj_box li span {
	font-size: 20px;
	color: red;
}
.tj_box li:last-child {
	border-right: 0;
}
.tj_box {
	width: 100%;
	height: 80px;
	background: #fff;
	box-shadow: 1px 3px 17px -5px #aeaeae;
	margin-top: 30px;
	padding: 20px 0;
}
.title_tj {
	font-size: 18px;
}
.time {
	font-size: 14px;
	color: #666;
}
.display_inline {
	display: inline;
	float: left;
}
.el-header,
.el-footer {
	color: #333;
	text-align: center;
	line-height: 60px;
	padding: 0px;
}
.el-aside {
	display: inline;
	float: left;
	background-color: #fff;
	color: #333;
	text-align: center;
	line-height: 200px;
	width: 300px !important;
}
.el-main {
	display: inline;
	float: left;
	background-color: #f3f5f6;
}
body > .el-container {
	margin-bottom: 40px;
}
.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
	line-height: 260px;
}
.el-container:nth-child(7) .el-aside {
	line-height: 320px;
}
.el-collapse-item__header {
	padding-left: 6px !important;
	font-weight: 800 !important;
}
.askitem {
	width: 32%;
	height: 80px;
	margin: 1px;
	cursor: pointer;
}
.type-item-icon {
	height: 50px;
	line-height: 86px;
	text-align: center;
}
.type-item-title {
	height: 30px;
	line-height: 30px;
	text-align: center;
	font-size: 8px;
}
.item_container {
	margin-top: 8px;
	background-color: #fff;
	margin-left: 0px !important;
	margin-right: 0px !important;
	padding-top: 6px;
	padding-bottom: 6px;
}
.item_container_hover {
	border: 2px #409eff solid;
	border-radius: 3px;
}
.el-input__inner {
	border: 0px;
	border-radius: 0;
	padding-left: 5px;
	padding-right: 5px;
}
.el-input__inner:hover {
	background-color: #aaa;
}
.operate_td {
	width: 30px;
	height: 30px;
	font-size: 26px;
	background-color: cornflowerblue;
	text-align: center;
	line-height: 30px;
}
.el-tooltip {
	padding-top: 0px !important;
}
.el-menu-item {
	margin-left: 0px !important;
}
.ck-content {
	min-height: 200px;
}
.el-divider--horizontal {
	margin: 0px !important;
}
.operate_item {
	height: 60px;
	line-height: 60px;
	width: 90%;
	margin: 0px auto;
}
</style>
<style>
.el-collapse-item__header {
	margin-left: 10px !important;
	font-weight: bold;
	font-size: 16px;
}
.ck-editor__editable_inline {
	min-height: 200px;
}
.el-collapse-item__header {
	margin-left: 13px;
	font-weight: bold;
}
.wjTitle > input {
	border: 0px !important;
	text-align: center;
}
input {
	border: 0px !important;
}
input:hover {
	border: 1px #aaa dashed !important;
}
.option_input > input {
	height: 35px !important;
	line-height: 35px !important;
	border: 1px #aaa solid !important;
}
.option_input > input:hover {
	height: 35px !important;
	line-height: 35px !important;
	border: 1px #aaa solid !important;
}
.left {
	float: left;
	margin-left: 6px;
}
.right {
	float: right;
}
.el-dialog__body {
	padding: 0px 7px !important;
	color: #606266 !important;
	font-size: 14px !important;
	word-break: break-all !important;
}
.el-submenu__title {
	text-align: left !important;
}
.el-collapse-item__header {
	width: 242px !important;
}
</style>
